import moment from 'moment';
import { CSVPrinter } from 'static/classes/CSVPrinter';
import { Notyf } from 'notyf';
import { format_value } from 'shared/common/junkdrawer';

function KPIVariableCount(data){
    // Defines a variable name, a month, a year, and a count
    //
    var self  = this;
    self.type = "KPIVariableCount"

    self.count = ko.observable(data.count).extend(
        {number_format:data.count_format || 'number'}
    );

    self.month = ko.observable(data.month);
    self.year = ko.observable(data.year);
};

function KPICountVariable(data){
  // Defines a variable name, a month, a year, and a count

  var self  = this;
  self.type = data.type;

  self.count_variable = data.count_variable;
  self.data_variable = data.data_variable;
  self.opt_count_variable = data.opt_count_variable || undefined;
  self.opt_data_variable = data.opt_data_variable || undefined;

  self.primary = ko.observable(data.primary || false);
  self.description = ko.observable(data.description);
  self.format = data.format;
  self.calc_avg = data.calc_avg || false;
  self.fixed_digits = data.fixed_digits || undefined;
  self.rowspan = data.rowspan || undefined;
  self.subrow = data.subrow || false;
  self.addpadding = data.addpadding || false;

  self.group = data.group;
  self.filter = data.filter || data.type;

  self.show_row = function(show_aufwand){
      return true;
  };

};


export function KPIViewModel(data) {

    var self = this;
    self.type = "KPIViewModel";

    data.rootvm = data.rootvm;
    self.web_host = data.rootvm.web_host;

    self.csvprint = new CSVPrinter(data);


    self.quarters = {1:[1, 2, 3],
                     2:[4, 5, 6],
                     3:[7, 8, 9],
                     4:[10, 11, 12]}

    self.is_busy = ko.observable(false);

    self.current_month = ko.observable(moment().month()+1);

    self.selected_years = ko.observableArray([2025, 2026]);
	self.selected_count_variables = ko.observableArray([]);
	self.filter_count_variables = ko.observableArray([]);
  self.sel_filter_count_variables = ko.observableArray([]);

   	//self.selected_count_variable = ko.observable();
    self.possible_years = ko.observableArray([2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013]);

    self.show_q1 = ko.observable(true);
    self.show_q2 = ko.observable(true);
    self.show_q3 = ko.observable(true);
    self.show_q4 = ko.observable(true);

    self.show_opt = ko.observable(false);
    self.show_aufwand = ko.observable(true);
    self.group_vis = ko.observableArray([]);


	// observes an observable array
	self.selected_count_group = ko.observableArray();

    self.months = ko.observableArray([
         {'text':'January', 'month_num':1},
         {'text':'February', 'month_num':2},
         {'text':'March', 'month_num':3},
         {'text':'April', 'month_num':4},
         {'text':'May', 'month_num':5},
         {'text':'June', 'month_num':6},
         {'text':'July', 'month_num':7},
         {'text':'August', 'month_num':8},
         {'text':'September', 'month_num':9},
         {'text':'October', 'month_num':10},
         {'text':'November', 'month_num':11},
         {'text':'December', 'month_num':12}]);

    self.count_value_by_month_year = function(observable_array, month, year, opt=false){
      //console.log(observable_array.count_variable());
      let ret = '';
      const item_var = opt ? observable_array.opt_count_variable : observable_array.count_variable;

      const item = ko.utils.arrayFirst(item_var(), function (cv) {
        return cv.month() == month && cv.year() == year;
      });

      if (item) {
        ret = format_value(item.count(), observable_array.format, observable_array.fixed_digits);
      }
      return opt ? '('+ret+')' : ret;
    };

    self.sum_value_by_year = function (kpi_count_variable, year, quarter=null, opt=false){
      if(kpi_count_variable.data_variable.indexOf('distinct') >= 0){
        return 'n/a';
      }
      else{
        quarter = parseInt(quarter);
        let sum = 0;
        let count = 0;
        const item_var = opt ? kpi_count_variable.opt_count_variable : kpi_count_variable.count_variable;

        ko.utils.arrayForEach(item_var(), function(item) {
          const item_year = parseInt(item.year());
          const item_month = parseInt(item.month());

          if (year == item_year && (!quarter ||
              (quarter && self.quarters[quarter].indexOf(item_month) >= 0))) {
            sum +=  parseFloat(item.count());
            count += 1;
          }
        });

        if (kpi_count_variable.format == 'percent' ||
            kpi_count_variable.calc_avg ||
            kpi_count_variable.data_variable=='average_gage' ){

          if(count > 0){
            const ret = format_value((sum / count), kpi_count_variable.format, kpi_count_variable.fixed_digits);

            return opt ? '('+ret+')' : ret;
          }
        }

        const ret = format_value(sum, kpi_count_variable.format, kpi_count_variable.fixed_digits);

        return opt ? '('+ret+')' : ret;
      }
    };

  const BG_COLORS = {
    2013: 'stylish',
    2014: 'black',
    2015: 'blue-grey',
    2016: 'grey',
    2017: 'brown',
    2018: 'indigo',
    2019: 'cyan',
    2020: 'green',
    2021: 'teal',
    2022: 'lime',
    2023: 'yellow',
    2024: 'purple',
    2025: 'orange',
 }

  self.bgColor = function(year, primary=false) {
    const suffix = primary ? '-light' : '-slight';
    const color = BG_COLORS[year] ? BG_COLORS[year] : 'white';
    return 'bg-' + color + suffix;
  }

  self.context = ko.observable();
  self.context.subscribe(function(){
    self.context_switch(self.context());
  });

  self.initialize = function(){
    self.notfy = new Notyf();
		/*
    self.is_busy(true);
    // pull in our data, build our table
    Promise.all([
		  self.lookup_overall_conversion(),
      self.lookup_user_kpi_data(),
      self.lookup_balance_kpi_data(),
      self.lookup_funnel_kpi_data(),
      self.lookup_cashflow_data(),
      self.lookup_external_balances(),
      self.lookup_google_counts()
    ]).then(self.is_busy(false));
		*/
    // check if context is needed after init
    //self.context_switch();
  }

  self.context_switch = function() {
		//console.log('context: ' + self.context());
    self.is_busy(true);
		switch (self.context()) {
			case 'sales':
				// pull in our data, build our table
				Promise.all([
					self.lookup_balance_kpi_data()
				]).then(
					self.is_busy(false),
					document.title = "KPI - Contracted Services",
					self.change_page(self.balance_variables())
				);
				break;
			case 'cashflow':
				// pull in our data, build our table
				Promise.all([
					self.lookup_cashflow_data(),
				]).then(
					self.is_busy(false),
					document.title = "KPI - Delivered Services",
					self.change_page(self.cashflow_variables(), false)
				);
				break;
			case 'community-activity':
				// pull in our data, build our table
				Promise.all([
					self.lookup_user_kpi_data(),
					self.lookup_funnel_kpi_data()
				]).then(
					self.is_busy(false),
					document.title = "KPI - Community activity",
					self.change_page(self.member_count_variables())
					);
					break;
			case 'conversion-funnel':
				// pull in our data, build our table
				Promise.all([
					self.lookup_overall_conversion(),
					self.lookup_google_counts()
				]).then(
					self.is_busy(false),
					document.title = "KPI - Conversion funnel",
					self.change_page(self.overall_conversion(), false, true)
				);
				break;

			case 'acquisition-funnel':
				// pull in acquisition funnel data by referrer source
				Promise.all([
					self.lookup_acquisition_funnel()
				]).then(
					self.is_busy(false),
					document.title = "KPI - Acquisition Funnel",
					self.change_page(self.acquisition_variables())
				);
				break;

			case 'event-lifecycle':
				Promise.all([
					self.lookup_event_lifecycle()
				]).then(
					self.is_busy(false),
					document.title = "KPI - Event Lifecycle",
					self.change_page(self.lifecycle_variables())
				);
				break;

			default:
				break;
		}
    self.is_busy(false);
  }
/*
  self.sel_filter_count_variables.subscribe(function(changes) {
    changes.forEach(function(change) {
      if (change.status === 'added') {
        console.log("Added! The added element is:", change.value);
        if (self.selected_count_variables.indexOf(change.value) == -1) {
          self.selected_count_variables.push(change.value);
        }
      }
      else if (change.status === 'deleted') {
        console.log("Removed! The removed element is:", change.value);
        if (self.selected_count_variables.indexOf(change.value) != -1) {
          self.selected_count_variables.remove(change.value);
        }
      }
    });
  }, null, "arrayChange");
*/

  self.onSelectFilter = function(option, checked) {
		if (checked === true) {
			//console.log("Added! The added element is:", $(option).val());
			self.selected_count_variables.push($(option).val());
		} else if (checked === false) {
			//console.log("Removed! The removed element is:", $(option).val());
			self.selected_count_variables.remove($(option).val());
		}
  }
  self.onSelectAllFilter = () => {
		//console.log("onchange select all");
		self.filter_count_variables().map((item) => {
			self.selected_count_variables.push(item.filter)
		});
  }
  self.onDeselectAllFilter = () => {
		//console.log("onchange deselect all");
		self.filter_count_variables().map((item) => {
			self.selected_count_variables.remove(item.filter);
		});
  }

  self.change_page = function(variables, show_external_balance, show_google_count){
    self.selected_count_group(variables);

    self.filter_count_variables.removeAll();
    self.selected_count_variables.removeAll();

    variables.forEach(function(item) {
      if (!item.subrow) {
        if (self.sel_filter_count_variables.indexOf(item.filter) == -1) {
          self.filter_count_variables.push(item);
          self.sel_filter_count_variables.push(item.filter);
        }
      }
      self.selected_count_variables.push(item.filter)
    });

    self.show_external_balance(show_external_balance === true);
    self.show_google_traffic_count(show_google_count === true);
  }

	// kpis/community-activity (DONE)
	//#region user
	self.member_count_variables = ko.observableArray([]);

	self.people_monthly_counts = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.people_monthly_counts,
		'primary': true,
		'description': 'New user signup that have confirmed their account',
		'type':'Member Signup',
		'data_variable':'confirmed_people_count'
	}));

	self.artist_monthly_counts = ko.observableArray([]);
  self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.artist_monthly_counts,
		'type':'Artist Signup',
		'description': 'Artist created count',
		'data_variable':'artist_count'
	}));

	self.host_monthly_counts = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.host_monthly_counts,
		'type':'Host Signup',
		'description': 'Host created count',
		'data_variable':'host_count'
	}));

	self.non_host_other_monthly_counts = ko.observableArray([]);
  self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.non_host_other_monthly_counts,
		'type':'Other Signup',
		'description': 'Members who have not created a host or an artist',
		'data_variable':'non_host_artist'
	}));

	self.member_logins = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.member_logins,
		'primary': true,
		'description': 'Unique user logins (one login per user)',
		'type':'Member Login',
		'data_variable':'member_logins'
	}));

	self.artist_logins = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.artist_logins,
		'type':'Artist Login',
		'description': 'Distinct Artists that logged in this month',
		'data_variable':'artist_logins'
	}));

	self.host_logins = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.host_logins,
		'type':'Host Logins',
		'description': 'Distinct Hosts that logged in this month',
		'data_variable':'host_logins'
	}));

	self.other_logins = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.other_logins,
		'type':'Other Logins',
		'description': 'Logins that have neither host or artist profile',
		'data_variable':'other_logins'
	}));

	self.conv_estimated_event_invites= ko.observableArray([]);
	self.raw_invites = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'type':'Est. Invites (raw)',
		'description':'Estimated Invites sent out',
		'primary': true,
    'count_variable':self.conv_estimated_event_invites,
		'data_variable':'estimated_event_invites',
    'opt_count_variable':self.raw_invites,
		'opt_data_variable':'invites'
  }));

	self.requests = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.requests,
		'type':'Requests',
		'description': '1 count for every request sent from an artist to a host',
		'data_variable':'requests'
	}));

	self.matches = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.matches,
		'type':'Matches',
		'description': '1 count for every admin match sent an artist ',
		'data_variable':'matches'
	}));

	self.matches_with_approval = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.matches_with_approval,
		'type':'Matches With Approval',
		'description': '1 count for every admin match sent an artist and approved ',
		'data_variable':'matches_with_approval'
	}));


	self.confirms = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.confirms,
		'type':'Total Confirmed',
		'primary': true,
		'description': 'Counted if an event has entered the confirmed state',
		'data_variable':'confirms'
	}));

	self.unique_user_confirms= ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.unique_user_confirms,
		'type':'Confirms from Unique Users',
		'description': 'Counts how many individual users confirmed an event this month. If we have 10 confirms and 9 of them were from booking@sofaconcerts.org and 1 was from levis@sofaconcerts.org, then we will see a count of 2 here (2 unique users)',
		'data_variable':'unique_user_confirms'
	}));

	self.unique_new_user_confirms = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.unique_new_user_confirms,
		'type':'New user confirms',
		'description': 'This counts the number of confirms for which this was the first confirm ever for the user.',
		'data_variable':'unique_new_user_confirms'
	}));

	self.new_user_share= ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.new_user_share,
		'type':'Rate of New users to total users',
		'description': 'Of our unique users confirming a concert, what percentage of them are new users. ( Unique new users / total unique users )',
		'data_variable':'new_user_share',
		'format':'percent'
	}));

	self.existing_user_confirms = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.existing_user_confirms,
		'type':'Confirms from Existing Users',
		'description': 'Adds one to the count for every individual confirm that came from a user who has confirmed a concert previous to this month. For example, if 10 concerts are confirmed, and 5 of them are confirmed by booking@sofaconcerts.org (an existing user), this column will show 5. One edge case -- if I am a new user and I confirm two concerts in one month, we will still add 1 to the existing user confirms for the second concert.',
		'data_variable':'existing_user_confirms'
	}));

	self.existing_user_confirm_rate = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.existing_user_confirm_rate,
		'type':'Past user confirm %',
		'description': 'The rate of confirms from past user to new users (confirmed by a past user / total confirms )',
		'data_variable':'existing_user_confirm_rate',
		'format':'percent'
	}));

	self.confirms_from_invites = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.confirms_from_invites,
		'type':'Confirms from Invites',
		'primary': true,
		'description': 'Counted if an event began as a host invite and is now confirmed',
		'data_variable':'confirms_from_invites'
	}));

	self.confirms_from_matches = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.confirms_from_matches,
		'type':'Confirms from matches',
		'description': 'Counted if an event began as an admin match and is now confirmed',
		'data_variable':'confirms_from_matches'
	}));


	self.confirms_from_requests = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.confirms_from_requests,
		'type':'Confirms from Requests',
		'description': 'Counted if an event began as an artist request and is now confirmed',
		'data_variable':'confirms_from_requests'
	}));

	self.cancels = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.cancels,
		'type':'Cancelled concerts',
		'data_variable':'cancels'
	}));

	self.distinct_people = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.distinct_people,
		'primary': true,
		'description': 'Number of members (incl Artist and Host) that have taken some event action',
		'type':'People Actions',
		'data_variable':'distinct_people'
	}));

	self.distinct_hosts = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.distinct_hosts,
		'type':'Host Actions',
		'description': 'Number of unique hosts that have taken some event action',
		'data_variable':'distinct_hosts'
	}));

	self.distinct_artists = ko.observableArray([]);
	self.member_count_variables.push(new KPICountVariable({
		'count_variable':self.distinct_artists,
		'type':'Artist Actions',
		'description': 'Number of unique artists that have taken some event action',
		'data_variable':'distinct_artists'
	}));
	//#endregion users



	// kpis/sales (DONE)
	//#region balance
	self.balance_variables = ko.observableArray([]);

	self.total_sales = ko.observableArray([]);
	self.total_sales_netto = ko.observableArray([]);
	self.total_sales_platform = ko.observableArray([]);
   	self.total_sales_platform_netto = ko.observableArray([]);
	self.total_sales_platform_no_sofa = ko.observableArray([]);
    self.aufwand= ko.observableArray([]);
    self.gross_profit = ko.observableArray([]);
    self.gross_profit_netto = ko.observableArray([]);
    self.gross_profit_platform = ko.observableArray([]);
    self.gross_profit_platform_netto = ko.observableArray([]);
    self.gagen = ko.observableArray([]);
    self.commission = ko.observableArray([]);
    self.percent_provision = ko.observableArray([]);
    self.average_gage = ko.observableArray([]);
    self.fee_count = ko.observableArray([]);
    self.hat = ko.observableArray([]);
    self.hat_count = ko.observableArray([]);
    self.total_bookings_count = ko.observableArray([]);
    self.total_event_confirms = ko.observableArray([]);
    self.video_fee = ko.observableArray([]);
    self.video_count = ko.observableArray([]);

    // Songgeflüster
    self.gys_fee = ko.observableArray([]);
    self.gys_count = ko.observableArray([]);


    self.pro_artist_fee = ko.observableArray([]);
    self.pro_artist_count = ko.observableArray([]);
    self.pro_artist_accepted_count = ko.observableArray([]);
    self.external_fee = ko.observableArray([]);
    self.gift_card = ko.observableArray([]);
    self.gift_card_extra = ko.observableArray([]);
    self.gift_card_avg = ko.observableArray([]);
    self.gift_card_count = ko.observableArray([]);


	/*self.total_commission = ko.observableArray([]);
	self.flat_commission = ko.observableArray([]);
	self.bookings_count = ko.observable([]);
	self.average_booking_fee = ko.observable([]);
	self.percent_commission = ko.observable([]);*/
	// Add in variables
	self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.total_sales,
		'type':'AUSSENUMSATZ GESAMT',
	    'data_variable':'total_sales',
        'primary':true,
        'description':'Plattform plus externe Rechnungen (F, CF, PA, RS) MINUS Aufwand (by expenses date), alles brutto',
        'format':'euro',
        'opt_count_variable':self.total_sales_netto,
		'opt_data_variable':'total_sales_netto'}));

    /*
	self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.total_sales_netto,
		'type':'AUSSENUMSATZ GESAMT (NETTO)',
	    'data_variable':'total_sales_netto',
        'description':'Plattform plus externe Rechnungen (F, CF, PA, RS), alles netto',
        'format':'euro'}));*/

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.total_sales_platform,
		'type':'AUSSENUMSATZ PLATFORM',
	    'data_variable':'total_sales_platform',
        'primary':true,
        'description':'F, CF, PA, alles brutto',
        'format':'euro',
        'opt_count_variable':self.total_sales_platform_netto,
		'opt_data_variable':'total_sales_platform_netto'

        }));
    /*
    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.total_sales_platform_netto,
		'type':'AUSSENUMSATZ PLATFORM (NETTO)',
	    'data_variable':'total_sales_platform_netto',
        'description':'F, CF, PA, alles netto',
        'format':'euro'}));
    */
    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.total_sales_platform_no_sofa,
		'type':'AUSSENUMSATZ PLATFORM (no AGENCY)',
	    'data_variable':'total_sales_platform_no_sofa',
        'primary':false,
        'description':'F, CF, PA, alles brutto, where the Commission is greater than zero (>0)',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gross_profit,
		'type':'INNENUMSATZ GESAMT',
	    'data_variable':'gross_profit',
        'primary':true,
        'description':'C, CF, PA, RS, alles brutto',
        'format':'euro',
        'opt_count_variable':self.gross_profit_netto,
		'opt_data_variable':'gross_profit_netto'
        }));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.external_fee,
		'type':'RS RECHNUNGEN',
	    'data_variable':'external_fee',
        'description':'RS, brutto manuell eingetragen - creation date',
        'format':'euro'}));


    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.aufwand,
		'type':'AUFWAND (Gagen)',
	    'data_variable':'aufwand',
        'description':'Alle Gagen (brutto), die als Nebenkosten für RS-Rechnungen anfallen. Sie sind im Außenumsatz Plattform inkludiert -> keine doppelte Zählung. Marge = Betrag RS - Nebenkosten',
        'format':'euro',
        }));


    /* FOR NOW NETTO AS OPTIONAL
    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gross_profit_netto,
		'type':'INNENUMSATZ GESAMT (netto)',
	    'data_variable':'gross_profit_netto',
        'primary':false,
        'description':'C, CF, PA, RS, alles netto',
        'format':'euro'}));
    */

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gross_profit_platform,
		'type':'INNENUMSATZ PLATTFORM',
	    'data_variable':'gross_profit_platform',
        'primary':true,
        'description':'C, CF, PA, alles brutto',
        'format':'euro',
        'opt_count_variable':self.gross_profit_platform_netto,
		'opt_data_variable':'gross_profit_platform_netto'

        }));
    /*
    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gross_profit_platform_netto,
		'type':'INNENUMSATZ PLATTFORM (netto)',
	    'data_variable':'gross_profit_platform_netto',
        'primary':false,
        'description':'C, CF, PA, alles netto',
        'format':'euro'}));
    */

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gagen,
		'type':'KÜNSTLERGAGEN',
	    'data_variable':'gagen',
        'primary':true,
        'description':'F - brutto, inkl. 2% Buchungsgebühr, durchlaufende Posten',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.commission,
		'type':'PROVISION',
	    'data_variable':'commission',
        'primary':true,
        'description':'C - brutto, inkl. 2% Buchungsgebühr',
        'format':'euro'}));


    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.percent_provision,
		'type':'% PROVISION',
	    'data_variable':'percent_provision',
        'primary':false,
        'description':'C/F in %',
        'format':'percent'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.average_gage,
		'type':'ø GAGE',
	    'data_variable':'average_gage',
        'primary':false,
        'description':'ø Gage aller Konzerte mit fester Gage oder Garantie',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.fee_count,
		'type':'# BUCHUNGEN',
	    'data_variable':'fee_count',
        'primary':false,
        'description':'Anzahl Konzerte mit fester Gage oder Garantie',
        'format':'number'}));


    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.hat,
		'type':'PAUSCHALE',
	    'data_variable':'hat',
        'primary':true,
        'description':'CF, brutto',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.hat_count,
		'type':'# BUCHUNGEN',
	    'data_variable':'hat_count',
        'primary':false,
        'description':'Anzahl Konzerte mit Nutzungs-Pauschale',
        'format':'number'}));

    self.balance_variables.push(new KPICountVariable({
      'count_variable':self.total_bookings_count,
		  'type':'# BUCHUNGEN GESAMT',
	    'data_variable':'total_bookings_count',
      'primary':true,
      'description':'Anzahl aller gebuchten Konzerte (if an invoice has been cancelled, then it <b>will</b> be counted. Cancelled are now counted in Delivered Services. ( opt. - Any event that has entered the confirmed state - excluding external. This number in parentheses includes concerts that may later be cancelled ). Does not include Video (Botschaft, Überraschungsanruf, Concert in a Box).',
      'format':'number'
    }));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.video_fee,
		'type':'VIDEO BOTSCHAFT',
	    'data_variable':'video_fee',
        'primary':true,
        'description':'F, brutto (Botschaft, Überraschungsanruf, Concert in a Box)',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.video_count,
		'type':'# VIDEOS',
	    'data_variable':'video_count',
        'primary':false,
        'description':'Anzahl Video Botschaft + Video Überraschungsanruf + Concert in A box',
        'format':'number'}));


    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gys_fee,
		'type':'SONGGEFLÜSTER',
	    'data_variable':'gys_fee',
        'primary':true,
        'description':'F, brutto (Songgeflüster)',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gys_count,
		'type':'# SONGGEFLÜSTER',
	    'data_variable':'gys_count',
        'primary':false,
        'description':'Anzahl Songgeflüster',
        'format':'number'}));


    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.pro_artist_fee,
		'type':'PRO KÜNSTLER',
	    'data_variable':'pro_artist_fee',
        'primary':true,
        'description':'PA, brutto',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.pro_artist_accepted_count,
		'type':'# PRO KÜNSTLER ACCEPTED',
	    'data_variable':'pro_artist_accepted_count',
        'primary':false,
        'description':'Anzahl accepted Mitgliedschaften',
        'format':'number'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.pro_artist_count,
		'type':'# PRO KÜNSTLER',
	    'data_variable':'pro_artist_count',
        'primary':false,
        'description':'Anzahl neue/verlängerte Mitgliedschaften',
        'format':'number'}));





    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gift_card,
		'type':'GUTSCHEIN WERT',
	    'data_variable':'gift_card',
        'primary':true,
        'description':'Gesamt Summe aller verkauften Gutscheine',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gift_card_extra,
		'type':'GUTSCHEIN PAKET',
	    'data_variable':'gift_card_extra',
        'primary':true,
        'description':'Gesamt Summe aller verkauften Pakete',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gift_card_avg,
		'type':'ø GUTSCHEIN WERT',
	    'data_variable':'gift_card_avg',
        'primary':false,
        'description':'ø Wert Gutscheine (ohne Paket Werte)',
        'format':'euro'}));

    self.balance_variables.push(new KPICountVariable(
		{'count_variable':self.gift_card_count,
		'type':'# GUTSCHEINE',
	    'data_variable':'gift_card_count',
        'primary':false,
        'description':'Anzahl verkaufte Gutscheine',
        'format':'number'}));
	//#endregion balance

  // kpis/cashflow TAB
	//#region cashflow
    self.cashflow_variables = ko.observableArray([]);

    self.gross_turnover = ko.observableArray([]);
    self.platform_internal_turnover = ko.observableArray([]);
    self.commission = ko.observableArray([]);
    self.commission_due = ko.observableArray([]);
    self.hat = ko.observableArray([]);
    self.pro_artist_fee = ko.observableArray([]);
    self.external_fee = ko.observableArray([]);
    self.cancelled_brutto= ko.observableArray([]);
    self.cancelled_fee_brutto= ko.observableArray([]);
    self.refunded_brutto= ko.observableArray([]);
    self.refunded_fee_brutto= ko.observableArray([]);
    self.discount_used= ko.observableArray([]);
    self.platform_netto = ko.observableArray([]);
    self.netto = ko.observableArray([]);
    self.expenses = ko.observableArray([]);
    self.netto_turnover_liquidity = ko.observableArray([]);
    //self.netto_turnover = ko.observableArray([]);


    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.gross_turnover,
		'format':'euro',
        'primary':true,
		'type':'AUSSENUMSATZ PLATTFORM',
	    'description': 'Gross merchandise sold value. Brutto. ( F, CF, PA) Must be a paid invoice -- so future invoices will not be counted until they are paid in)',
	    'data_variable':'platform_gross_turnover',
        }));

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.platform_internal_turnover,
   		'format':'euro',
        'primary':true,
		'type':' INNENUMSATZ PLATTFORM',
	    'description': 'Internal turnover (C, CF, PA). Brutto. Paid.',
	    'data_variable':'platform_internal_turnover',
        'opt_count_variable':self.platform_netto,
		'opt_data_variable':'platform_netto_turnover'
        }));

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.commission,
		'format':'euro',
		'type':'C',
	    'description': 'Paid in Commission (C). Brutto. (What was actually paid in this month. Should match the MangoPay account, minor discrepancies may be due to cancellations of concerts in past months)',
	    'data_variable':'commission'}));

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.commission_due,
		'format':'euro',
		'type':'C (coming due)',
	    'description': 'Commission (C) Coming Due. Brutto. (Calculated as all C that have not yet been paid in and have a due_date anytime in the future).',
	    'data_variable':'commission_due'}));


    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.hat,
		'format':'euro',
		'type':'CF',
	    'description': 'Flat Commission Invoices CF Brutto (PAID)',
	    'data_variable':'hat'}));

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.pro_artist_fee,
		'format':'euro',
		'type':'PA ',
	    'description': 'Pro Artist PA Brutto (Paid)',
	    'data_variable':'pro_artist_fee'}));

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.external_fee,
		'format':'euro',
		'type':'RS Rechnungen',
	    'description': 'External Invoices Brutto. (by creation date -- when it is included in FIBU)',
	    'data_variable':'external_fee'}));


    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.cancelled_brutto,
		'format':'euro',
        'primary':true,
		'type':'Cancels',
	    'description': 'Cancelled concert attributed to the month in which they were cancelled (C Brutto) (opt Fee cancelled)',
	    'data_variable':'cancelled_brutto',
        'opt_count_variable':self.cancelled_fee_brutto,
		'opt_data_variable':'cancelled_fee_brutto'

        }));


    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.refunded_brutto,
		'format':'euro',
		'type':'Refunds',
	    'description': 'Refunded concerts attributed to the month they were refunded (paid out from MangoPay, not as discount code). (C Brutto) (opt Fee Refunded)',
	    'data_variable':'refunded_brutto',
        'opt_count_variable':self.refunded_fee_brutto,
		'opt_data_variable':'refunded_fee_brutto'

        }));

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.discount_used,
		'format':'euro',
		'type':'Discount Used',
	    'description': 'Discount codes used against fee invoices. These are not git cards but are either marketing (welcome_sofa) or a replacement for a cancelled concert (not refunded but rebooked).',
	    'data_variable':'discount_used'}));




    /*
    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.platform_netto,
        'primary': true,
		'format':'euro',
		'type':'Platform (netto) ',
	    'description': 'Platform Netto (before mwst) (C netto + CF netto + PA netto)',
	    'data_variable':'platform_netto_turnover'}));
    */

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.netto,
        'primary': true,
		'format':'euro',
		'type':'INNENUMSATZ GESAMT netto (Buchhaltung)',
	    'description': '“Platform netto (by paid date) + RS netto (by creation date), should match Buchhaltung',
	    'data_variable':'netto_turnover'}));

    self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.expenses,
        'primary': false,
		'format':'euro',
		'type':'AUFWAND netto',
	    'description': 'nicht inkludiert: Personalkosten und laufende Kosten wie: Miete, Steuerberater, Lohn).',
	    'data_variable':'expenses'}));



 self.cashflow_variables().push(new KPICountVariable({
		'count_variable':self.netto_turnover_liquidity,
        'primary': false,
		'format':'euro',
		'type':'INNENUMSATZ GESAMT netto (Liquidität)',
	    'description': 'Netto Total ( Platform netto (by paid date) + RS netto (by paid date)  + C coming_due (due date)), shows actual cashflow and expected cash flow',
	    'data_variable':'netto_turnover_liquidity'}));
	//#endregion cashflow

	// kpis/acquisition-funnel
	//#region acquisition
	self.acquisition_variables = ko.observableArray([]);

	// --- OVERALL TOTALS ---
	self.signups_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.signups_total,
		'type': 'SIGNUPS (Total)',
		'data_variable': 'signups_total',
		'primary': true,
		'format': 'number',
		'description': 'Total new user registrations from all sources',
		'filter': 'total'
	}));

	self.visitors_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitors_total,
		'type': 'Visitors (page_views)',
		'data_variable': 'visitors_total',
		'format': 'number',
		'description': 'Unique anonymous sessions (person_uuid IS NULL) across all channels.',
		'filter': 'total'
	}));

	self.visitor_signup_rate_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitor_signup_rate_total,
		'type': 'Visitor→Signup %',
		'data_variable': 'visitor_signup_rate_total',
		'format': 'percent',
		'description': 'Signups as % of unique anonymous visitors (all channels combined)',
		'filter': 'total'
	}));

	self.artist_signups_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_signups_total,
		'type': 'Artist Signups',
		'data_variable': 'artist_signups_total',
		'format': 'number',
		'description': 'Users who signed up as artists',
		'filter': 'total'
	}));

	self.artist_percent_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_percent_total,
		'type': 'Artist %',
		'data_variable': 'artist_percent_total',
		'format': 'percent',
		'description': '% of signups who are artists',
		'filter': 'total'
	}));

	self.invites_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invites_total,
		'type': 'Invites (count)',
		'data_variable': 'invites_total',
		'format': 'number',
		'description': 'Users who sent at least 1 invite',
		'filter': 'total'
	}));

	self.avg_invite_count_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_invite_count_total,
		'type': 'Avg Invite Count',
		'data_variable': 'avg_invite_count_total',
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'description': 'Average number of invites sent per user (for users who sent at least 1)',
		'filter': 'total'
	}));

	self.invite_rate_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invite_rate_total,
		'type': 'Invite Rate %',
		'data_variable': 'invite_rate_total',
		'format': 'percent',
		'description': '% of signups who sent at least 1 invite',
		'filter': 'total'
	}));

	self.approval_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_total,
		'type': 'Approvals (count)',
		'data_variable': 'approval_total',
		'format': 'number',
		'description': 'Users with at least 1 event in waiting_for_confirmation',
		'filter': 'total'
	}));

	self.approval_rate_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_rate_total,
		'type': 'Approval Rate %',
		'data_variable': 'approval_rate_total',
		'format': 'percent',
		'description': '% of signups with at least 1 event in waiting_for_confirmation',
		'filter': 'total'
	}));

	self.confirms_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirms_total,
		'type': 'Confirms (count)',
		'data_variable': 'confirms_total',
		'format': 'number',
		'description': 'Users with at least 1 confirmed booking',
		'filter': 'total'
	}));

	self.confirm_rate_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_rate_total,
		'type': 'Confirm Rate %',
		'data_variable': 'confirm_rate_total',
		'format': 'percent',
		'description': '% of signups with at least 1 confirmed booking',
		'filter': 'total'
	}));

	self.confirm_from_invite_rate_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_invite_rate_total,
		'type': 'Confirm/Invite %',
		'data_variable': 'confirm_from_invite_rate_total',
		'format': 'percent',
		'description': '% of users with invites who confirmed',
		'filter': 'total'
	}));

	self.confirm_from_approval_rate_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_approval_rate_total,
		'type': 'Confirm/Approval %',
		'data_variable': 'confirm_from_approval_rate_total',
		'format': 'percent',
		'description': '% of users with approvals who confirmed',
		'filter': 'total'
	}));

	self.fees_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.fees_total,
		'type': 'Total Fees €',
		'data_variable': 'fees_total',
		'format': 'euro',
		'filter': 'total'
	}));

	self.commission_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.commission_total,
		'type': 'Total Commission €',
		'data_variable': 'commission_total',
		'format': 'euro',
		'filter': 'total'
	}));

	self.no_approval_rate_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.no_approval_rate_total,
		'type': 'No Approval Rate %',
		'data_variable': 'no_approval_rate_total',
		'format': 'percent',
		'description': '% of users with invites who received no approvals',
		'filter': 'total'
	}));

	self.avg_approval_ratio_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_approval_ratio_total,
		'type': 'Avg Approval Ratio %',
		'data_variable': 'avg_approval_ratio_total',
		'format': 'percent',
		'description': 'Average (approvals / invites) per user',
		'filter': 'total'
	}));

	self.avg_fee_diff_total = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_fee_diff_total,
		'type': 'Avg Fee Diff €',
		'data_variable': 'avg_fee_diff_total',
		'format': 'euro',
		'description': 'Average fee change from invite to approval (positive = higher at approval)',
		'filter': 'total'
	}));

	// --- SEO ORGANIC ---
	self.signups_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.signups_organic,
		'type': 'SEO Organic (Google, Bing, Ecosia)',
		'data_variable': 'signups_organic',
		'primary': true,
		'group': 'organic',
		'rowspan': 17,
		'format': 'number',
		'description': 'Users from organic search (Google, Bing, Ecosia) without ad parameters (no gclid/c_id)',
		'filter': 'organic'
	}));

	self.visitors_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitors_organic,
		'type': 'Visitors (page_views)',
		'data_variable': 'visitors_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'number',
		'description': 'Unique anonymous sessions from organic search (Google, Bing, Ecosia referrer, no ad params).',
		'filter': 'organic'
	}));

	self.visitor_signup_rate_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitor_signup_rate_organic,
		'type': 'Visitor→Signup %',
		'data_variable': 'visitor_signup_rate_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'description': 'Signups as % of unique anonymous organic visitors for this month',
		'filter': 'organic'
	}));

	self.artist_signups_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_signups_organic,
		'type': 'Artist Signups',
		'data_variable': 'artist_signups_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'number',
		'filter': 'organic'
	}));

	self.artist_percent_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_percent_organic,
		'type': 'Artist %',
		'data_variable': 'artist_percent_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.invites_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invites_organic,
		'type': 'Invites',
		'data_variable': 'invites_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'number',
		'filter': 'organic'
	}));

	self.avg_invite_count_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_invite_count_organic,
		'type': 'Avg Invite Count',
		'data_variable': 'avg_invite_count_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'filter': 'organic'
	}));

	self.invite_rate_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invite_rate_organic,
		'type': 'Invite Rate %',
		'data_variable': 'invite_rate_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.approval_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_organic,
		'type': 'Approvals',
		'data_variable': 'approval_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'number',
		'filter': 'organic'
	}));

	self.approval_rate_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_rate_organic,
		'type': 'Approval Rate %',
		'data_variable': 'approval_rate_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.confirms_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirms_organic,
		'type': 'Confirms',
		'data_variable': 'confirms_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'number',
		'filter': 'organic'
	}));

	self.confirm_rate_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_rate_organic,
		'type': 'Confirm Rate %',
		'data_variable': 'confirm_rate_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.confirm_from_invite_rate_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_invite_rate_organic,
		'type': 'Confirm/Invite %',
		'data_variable': 'confirm_from_invite_rate_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.confirm_from_approval_rate_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_approval_rate_organic,
		'type': 'Confirm/Approval %',
		'data_variable': 'confirm_from_approval_rate_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.fees_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.fees_organic,
		'type': 'Fees €',
		'data_variable': 'fees_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'euro',
		'filter': 'organic'
	}));

	self.no_approval_rate_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.no_approval_rate_organic,
		'type': 'No Approval %',
		'data_variable': 'no_approval_rate_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.avg_approval_ratio_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_approval_ratio_organic,
		'type': 'Avg Approval Ratio %',
		'data_variable': 'avg_approval_ratio_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'percent',
		'filter': 'organic'
	}));

	self.avg_fee_diff_organic = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_fee_diff_organic,
		'type': 'Avg Fee Diff €',
		'data_variable': 'avg_fee_diff_organic',
		'group': 'organic',
		'subrow': true,
		'format': 'euro',
		'filter': 'organic'
	}));

	// --- GOOGLE ADS ---
	self.signups_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.signups_google_ads,
		'type': 'Google Ads (SEA)',
		'data_variable': 'signups_google_ads',
		'primary': true,
		'group': 'google_ads',
		'rowspan': 17,
		'format': 'number',
		'description': 'Users from Google Ads (has gclid or c_id parameter)',
		'filter': 'google-ads'
	}));

	self.visitors_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitors_google_ads,
		'type': 'Visitors (page_views)',
		'data_variable': 'visitors_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'number',
		'description': 'Unique anonymous sessions with gclid or c_id= in page URL.',
		'filter': 'google-ads'
	}));

	self.visitor_signup_rate_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitor_signup_rate_google_ads,
		'type': 'Visitor→Signup %',
		'data_variable': 'visitor_signup_rate_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'description': 'Signups as % of unique anonymous Google Ads visitors for this month',
		'filter': 'google-ads'
	}));

	self.artist_signups_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_signups_google_ads,
		'type': 'Artist Signups',
		'data_variable': 'artist_signups_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'number',
		'filter': 'google-ads'
	}));

	self.artist_percent_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_percent_google_ads,
		'type': 'Artist %',
		'data_variable': 'artist_percent_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.invites_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invites_google_ads,
		'type': 'Invites',
		'data_variable': 'invites_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'number',
		'filter': 'google-ads'
	}));

	self.avg_invite_count_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_invite_count_google_ads,
		'type': 'Avg Invite Count',
		'data_variable': 'avg_invite_count_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'filter': 'google-ads'
	}));

	self.invite_rate_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invite_rate_google_ads,
		'type': 'Invite Rate %',
		'data_variable': 'invite_rate_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.approval_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_google_ads,
		'type': 'Approvals',
		'data_variable': 'approval_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'number',
		'filter': 'google-ads'
	}));

	self.approval_rate_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_rate_google_ads,
		'type': 'Approval Rate %',
		'data_variable': 'approval_rate_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.confirms_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirms_google_ads,
		'type': 'Confirms',
		'data_variable': 'confirms_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'number',
		'filter': 'google-ads'
	}));

	self.confirm_rate_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_rate_google_ads,
		'type': 'Confirm Rate %',
		'data_variable': 'confirm_rate_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.confirm_from_invite_rate_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_invite_rate_google_ads,
		'type': 'Confirm/Invite %',
		'data_variable': 'confirm_from_invite_rate_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.confirm_from_approval_rate_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_approval_rate_google_ads,
		'type': 'Confirm/Approval %',
		'data_variable': 'confirm_from_approval_rate_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.fees_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.fees_google_ads,
		'type': 'Fees €',
		'data_variable': 'fees_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'euro',
		'filter': 'google-ads'
	}));

	self.no_approval_rate_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.no_approval_rate_google_ads,
		'type': 'No Approval %',
		'data_variable': 'no_approval_rate_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.avg_approval_ratio_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_approval_ratio_google_ads,
		'type': 'Avg Approval Ratio %',
		'data_variable': 'avg_approval_ratio_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'percent',
		'filter': 'google-ads'
	}));

	self.avg_fee_diff_google_ads = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_fee_diff_google_ads,
		'type': 'Avg Fee Diff €',
		'data_variable': 'avg_fee_diff_google_ads',
		'group': 'google_ads',
		'subrow': true,
		'format': 'euro',
		'filter': 'google-ads'
	}));

	// --- META (Facebook + Instagram) ---
	self.signups_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.signups_meta,
		'type': 'Meta (FB + IG)',
		'data_variable': 'signups_meta',
		'primary': true,
		'group': 'meta',
		'rowspan': 17,
		'format': 'number',
		'description': 'Users from Facebook and Instagram',
		'filter': 'meta'
	}));

	self.visitors_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitors_meta,
		'type': 'Visitors (page_views)',
		'data_variable': 'visitors_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'number',
		'description': 'Unique anonymous sessions with Meta signals (FB/IG referrer, utm_source=fb/ig/meta, or fbp/fbc cookie). Note: fbp/fbc may overcount if cookie persists after visit.',
		'filter': 'meta'
	}));

	self.visitor_signup_rate_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitor_signup_rate_meta,
		'type': 'Visitor→Signup %',
		'data_variable': 'visitor_signup_rate_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'description': 'Signups as % of unique anonymous Meta visitors for this month',
		'filter': 'meta'
	}));

	self.artist_signups_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_signups_meta,
		'type': 'Artist Signups',
		'data_variable': 'artist_signups_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'number',
		'filter': 'meta'
	}));

	self.artist_percent_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_percent_meta,
		'type': 'Artist %',
		'data_variable': 'artist_percent_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.invites_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invites_meta,
		'type': 'Invites',
		'data_variable': 'invites_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'number',
		'filter': 'meta'
	}));

	self.avg_invite_count_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_invite_count_meta,
		'type': 'Avg Invite Count',
		'data_variable': 'avg_invite_count_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'filter': 'meta'
	}));

	self.invite_rate_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invite_rate_meta,
		'type': 'Invite Rate %',
		'data_variable': 'invite_rate_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.approval_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_meta,
		'type': 'Approvals',
		'data_variable': 'approval_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'number',
		'filter': 'meta'
	}));

	self.approval_rate_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_rate_meta,
		'type': 'Approval Rate %',
		'data_variable': 'approval_rate_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.confirms_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirms_meta,
		'type': 'Confirms',
		'data_variable': 'confirms_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'number',
		'filter': 'meta'
	}));

	self.confirm_rate_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_rate_meta,
		'type': 'Confirm Rate %',
		'data_variable': 'confirm_rate_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.confirm_from_invite_rate_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_invite_rate_meta,
		'type': 'Confirm/Invite %',
		'data_variable': 'confirm_from_invite_rate_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.confirm_from_approval_rate_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_approval_rate_meta,
		'type': 'Confirm/Approval %',
		'data_variable': 'confirm_from_approval_rate_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.fees_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.fees_meta,
		'type': 'Fees €',
		'data_variable': 'fees_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'euro',
		'filter': 'meta'
	}));

	self.no_approval_rate_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.no_approval_rate_meta,
		'type': 'No Approval %',
		'data_variable': 'no_approval_rate_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.avg_approval_ratio_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_approval_ratio_meta,
		'type': 'Avg Approval Ratio %',
		'data_variable': 'avg_approval_ratio_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'percent',
		'filter': 'meta'
	}));

	self.avg_fee_diff_meta = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_fee_diff_meta,
		'type': 'Avg Fee Diff €',
		'data_variable': 'avg_fee_diff_meta',
		'group': 'meta',
		'subrow': true,
		'format': 'euro',
		'filter': 'meta'
	}));

	// --- OTHER SOURCES ---
	self.signups_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.signups_other,
		'type': 'Other Sources',
		'data_variable': 'signups_other',
		'primary': true,
		'group': 'other',
		'rowspan': 17,
		'format': 'number',
		'description': 'Artist pages, tiktok, pinterest, and other referrers (excluding Meta, Google Ads, organic)',
		'filter': 'other'
	}));

	self.visitors_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitors_other,
		'type': 'Visitors (page_views)',
		'data_variable': 'visitors_other',
		'group': 'other',
		'subrow': true,
		'format': 'number',
		'description': 'Unique anonymous sessions from other sources (artist pages, tiktok, pinterest, etc.).',
		'filter': 'other'
	}));

	self.visitor_signup_rate_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitor_signup_rate_other,
		'type': 'Visitor→Signup %',
		'data_variable': 'visitor_signup_rate_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'description': 'Not computed — Other channel mixes direct and referral traffic tracked separately in the Direct group.',
		'filter': 'other'
	}));

	self.artist_signups_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_signups_other,
		'type': 'Artist Signups',
		'data_variable': 'artist_signups_other',
		'group': 'other',
		'subrow': true,
		'format': 'number',
		'filter': 'other'
	}));

	self.artist_percent_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.artist_percent_other,
		'type': 'Artist %',
		'data_variable': 'artist_percent_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.invites_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invites_other,
		'type': 'Invites',
		'data_variable': 'invites_other',
		'group': 'other',
		'subrow': true,
		'format': 'number',
		'filter': 'other'
	}));

	self.avg_invite_count_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_invite_count_other,
		'type': 'Avg Invite Count',
		'data_variable': 'avg_invite_count_other',
		'group': 'other',
		'subrow': true,
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'filter': 'other'
	}));

	self.invite_rate_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.invite_rate_other,
		'type': 'Invite Rate %',
		'data_variable': 'invite_rate_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.approval_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_other,
		'type': 'Approvals',
		'data_variable': 'approval_other',
		'group': 'other',
		'subrow': true,
		'format': 'number',
		'filter': 'other'
	}));

	self.approval_rate_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.approval_rate_other,
		'type': 'Approval Rate %',
		'data_variable': 'approval_rate_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.confirms_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirms_other,
		'type': 'Confirms',
		'data_variable': 'confirms_other',
		'group': 'other',
		'subrow': true,
		'format': 'number',
		'filter': 'other'
	}));

	self.confirm_rate_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_rate_other,
		'type': 'Confirm Rate %',
		'data_variable': 'confirm_rate_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.confirm_from_invite_rate_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_invite_rate_other,
		'type': 'Confirm/Invite %',
		'data_variable': 'confirm_from_invite_rate_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.confirm_from_approval_rate_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.confirm_from_approval_rate_other,
		'type': 'Confirm/Approval %',
		'data_variable': 'confirm_from_approval_rate_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.fees_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.fees_other,
		'type': 'Fees €',
		'data_variable': 'fees_other',
		'group': 'other',
		'subrow': true,
		'format': 'euro',
		'filter': 'other'
	}));

	self.no_approval_rate_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.no_approval_rate_other,
		'type': 'No Approval %',
		'data_variable': 'no_approval_rate_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.avg_approval_ratio_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_approval_ratio_other,
		'type': 'Avg Approval Ratio %',
		'data_variable': 'avg_approval_ratio_other',
		'group': 'other',
		'subrow': true,
		'format': 'percent',
		'filter': 'other'
	}));

	self.avg_fee_diff_other = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.avg_fee_diff_other,
		'type': 'Avg Fee Diff €',
		'data_variable': 'avg_fee_diff_other',
		'group': 'other',
		'subrow': true,
		'format': 'euro',
		'filter': 'other'
	}));

	// --- DIRECT TRAFFIC (visitor-only, no funnel equivalent) ---
	self.visitors_direct = ko.observableArray([]);
	self.acquisition_variables.push(new KPICountVariable({
		'count_variable': self.visitors_direct,
		'type': 'Direct Traffic (Visitors only)',
		'data_variable': 'visitors_direct',
		'primary': true,
		'group': 'direct',
		'rowspan': 1,
		'format': 'number',
		'description': 'Sessions with no referrer and no UTM params. No signup funnel equivalent — direct signups appear in "Other Sources" above.',
		'filter': 'direct'
	}));

	// --- EVENT TYPE BREAKDOWN ---
	const eventTypes = ['birthday', 'wedding', 'corporate_event', 'sofaconcert', 'other'];
	const eventTypeLabels = {
		'birthday': 'Birthday',
		'wedding': 'Wedding',
		'corporate_event': 'Corporate',
		'sofaconcert': 'Sofaconcert',
		'other': 'Other Events'
	};
	const channelSuffixes = [
		{suffix: 'total', label: '', filter: 'event-types', group: 'et'},
		{suffix: 'organic', label: ' (Organic)', filter: 'event-types-go', group: 'et_go'},
		{suffix: 'google_ads', label: ' (GA)', filter: 'event-types-ga', group: 'et_ga'},
		{suffix: 'meta', label: ' (Meta)', filter: 'event-types-meta', group: 'et_meta'},
		{suffix: 'other', label: ' (Oth)', filter: 'event-types-ot', group: 'et_ot'}
	];

	// For each event type, show users, approval count, approval rate, confirms count, confirm rate
	eventTypes.forEach(function(evType, evIndex) {
		channelSuffixes.forEach(function(ch) {
			const groupName = ch.group + '_' + evType;
			const filterName = ch.filter;

			// Users (primary row)
			self['users_' + evType + '_' + ch.suffix] = ko.observableArray([]);
			self.acquisition_variables.push(new KPICountVariable({
				'count_variable': self['users_' + evType + '_' + ch.suffix],
				'type': eventTypeLabels[evType] + ch.label,
				'data_variable': 'users_' + evType + '_' + ch.suffix,
				'primary': true,
				'group': groupName,
				'rowspan': 6,
				'format': 'number',
				'description': 'Users with ' + eventTypeLabels[evType] + ' events',
				'filter': filterName
			}));

			// Approvals (count)
			self['approval_' + evType + '_' + ch.suffix] = ko.observableArray([]);
			self.acquisition_variables.push(new KPICountVariable({
				'count_variable': self['approval_' + evType + '_' + ch.suffix],
				'type': 'Approvals',
				'data_variable': 'approval_' + evType + '_' + ch.suffix,
				'group': groupName,
				'subrow': true,
				'format': 'number',
				'filter': filterName
			}));

			// Approval Rate %
			self['approval_rate_' + evType + '_' + ch.suffix] = ko.observableArray([]);
			self.acquisition_variables.push(new KPICountVariable({
				'count_variable': self['approval_rate_' + evType + '_' + ch.suffix],
				'type': 'Approval Rate %',
				'data_variable': 'approval_rate_' + evType + '_' + ch.suffix,
				'group': groupName,
				'subrow': true,
				'format': 'percent',
				'filter': filterName
			}));

			// Confirms (count)
			self['confirms_' + evType + '_' + ch.suffix] = ko.observableArray([]);
			self.acquisition_variables.push(new KPICountVariable({
				'count_variable': self['confirms_' + evType + '_' + ch.suffix],
				'type': 'Confirms',
				'data_variable': 'confirms_' + evType + '_' + ch.suffix,
				'group': groupName,
				'subrow': true,
				'format': 'number',
				'filter': filterName
			}));

			// Confirm Rate %
			self['confirm_rate_' + evType + '_' + ch.suffix] = ko.observableArray([]);
			self.acquisition_variables.push(new KPICountVariable({
				'count_variable': self['confirm_rate_' + evType + '_' + ch.suffix],
				'type': 'Confirm Rate %',
				'data_variable': 'confirm_rate_' + evType + '_' + ch.suffix,
				'group': groupName,
				'subrow': true,
				'format': 'percent',
				'filter': filterName
			}));

			// Fee Diff (approval fee - invite fee)
			self['fee_diff_' + evType + '_' + ch.suffix] = ko.observableArray([]);
			self.acquisition_variables.push(new KPICountVariable({
				'count_variable': self['fee_diff_' + evType + '_' + ch.suffix],
				'type': 'Fee Diff €',
				'data_variable': 'fee_diff_' + evType + '_' + ch.suffix,
				'group': groupName,
				'subrow': true,
				'format': 'euro',
				'filter': filterName
			}));
		});
	});
	//#endregion acquisition

	// kpis/event-lifecycle
	//#region lifecycle
	self.lifecycle_variables = ko.observableArray([]);

	const lifecycleEventTypes = ['birthday', 'wedding', 'corporate_event', 'sofaconcert', 'other'];
	const lifecycleEventTypeLabels = {
		'birthday': 'Birthday',
		'wedding': 'Wedding',
		'corporate_event': 'Corporate',
		'sofaconcert': 'Sofaconcert',
		'other': 'Other Events'
	};

	// --- TOTAL ---
	self.lc_estimated_events_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_estimated_events_total,
		'type': 'ESTIMATED EVENTS (Total)',
		'data_variable': 'estimated_events_total',
		'primary': true,
		'format': 'number',
		'description': 'Total estimated events (grouped by creator, event type, possible dates)',
		'filter': 'total'
	}));

	self.lc_total_invites_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_total_invites_total,
		'type': 'Total Invites',
		'data_variable': 'total_invites_total',
		'format': 'number',
		'description': 'Total number of invites sent',
		'filter': 'total'
	}));

	self.lc_avg_invites_per_event_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_avg_invites_per_event_total,
		'type': 'Avg Invites/Event',
		'data_variable': 'avg_invites_per_event_total',
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'description': 'Average invites sent per estimated event',
		'filter': 'total'
	}));

	self.lc_avg_invite_fee_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_avg_invite_fee_total,
		'type': 'Avg Invite Fee',
		'data_variable': 'avg_invite_fee_total',
		'format': 'euro',
		'calc_avg': true,
		'description': 'Average fee at invite stage',
		'filter': 'total'
	}));

	self.lc_events_with_approval_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_events_with_approval_total,
		'type': 'Events w/ Approval',
		'data_variable': 'events_with_approval_total',
		'format': 'number',
		'description': 'Estimated events with at least 1 approval',
		'filter': 'total'
	}));

	self.lc_approval_rate_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_approval_rate_total,
		'type': 'Approval Rate %',
		'data_variable': 'approval_rate_total',
		'format': 'percent',
		'calc_avg': true,
		'description': '% of estimated events that reached approval',
		'filter': 'total'
	}));

	self.lc_events_no_approval_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_events_no_approval_total,
		'type': 'Events No Approval',
		'data_variable': 'events_no_approval_total',
		'format': 'number',
		'description': 'Estimated events that never reached approval',
		'filter': 'total'
	}));

	self.lc_events_confirmed_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_events_confirmed_total,
		'type': 'Events Confirmed',
		'data_variable': 'events_confirmed_total',
		'format': 'number',
		'description': 'Estimated events with at least 1 confirmation',
		'filter': 'total'
	}));

	self.lc_confirm_rate_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_confirm_rate_total,
		'type': 'Confirm Rate %',
		'data_variable': 'confirm_rate_total',
		'format': 'percent',
		'calc_avg': true,
		'description': '% of estimated events that confirmed',
		'filter': 'total'
	}));

	self.lc_confirm_from_approval_rate_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_confirm_from_approval_rate_total,
		'type': 'Confirm/Approval %',
		'data_variable': 'confirm_from_approval_rate_total',
		'format': 'percent',
		'calc_avg': true,
		'description': '% of approved events that confirmed',
		'filter': 'total'
	}));

	self.lc_no_approval_rate_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_no_approval_rate_total,
		'type': 'No Approval Rate %',
		'data_variable': 'no_approval_rate_total',
		'format': 'percent',
		'calc_avg': true,
		'description': '% of estimated events that never reached approval',
		'filter': 'total'
	}));

	self.lc_events_cancelled_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_events_cancelled_total,
		'type': 'Events Cancelled',
		'data_variable': 'events_cancelled_total',
		'format': 'number',
		'description': 'Estimated events with at least 1 cancellation',
		'filter': 'total'
	}));

	self.lc_avg_approval_fee_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_avg_approval_fee_total,
		'type': 'Avg Approval Fee',
		'data_variable': 'avg_approval_fee_total',
		'format': 'euro',
		'calc_avg': true,
		'description': 'Average fee at approval stage',
		'filter': 'total'
	}));

	self.lc_avg_confirm_fee_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_avg_confirm_fee_total,
		'type': 'Avg Confirm Fee',
		'data_variable': 'avg_confirm_fee_total',
		'format': 'euro',
		'calc_avg': true,
		'description': 'Average fee at confirm stage',
		'filter': 'total'
	}));

	self.lc_fee_diff_invite_to_approval_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_fee_diff_invite_to_approval_total,
		'type': 'Fee Diff Invite→Approval',
		'data_variable': 'fee_diff_invite_to_approval_total',
		'format': 'euro',
		'calc_avg': true,
		'description': 'Average fee change from invite to approval',
		'filter': 'total'
	}));

	self.lc_fee_diff_invite_to_confirm_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_fee_diff_invite_to_confirm_total,
		'type': 'Fee Diff Invite→Confirm',
		'data_variable': 'fee_diff_invite_to_confirm_total',
		'format': 'euro',
		'calc_avg': true,
		'description': 'Average fee change from invite to confirm',
		'filter': 'total'
	}));

	self.lc_avg_days_to_approval_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_avg_days_to_approval_total,
		'type': 'Avg Days to Approval',
		'data_variable': 'avg_days_to_approval_total',
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'description': 'Average days from first invite to approval',
		'filter': 'total'
	}));

	self.lc_avg_days_to_confirm_total = ko.observableArray([]);
	self.lifecycle_variables.push(new KPICountVariable({
		'count_variable': self.lc_avg_days_to_confirm_total,
		'type': 'Avg Days to Confirm',
		'data_variable': 'avg_days_to_confirm_total',
		'format': 'number',
		'calc_avg': true,
		'fixed_digits': 1,
		'description': 'Average days from first invite to confirmation',
		'filter': 'total'
	}));

	// --- PER EVENT TYPE ---
	lifecycleEventTypes.forEach(function(evType) {
		const groupName = 'lc_' + evType;
		const filterName = 'lc-' + evType;

		self['lc_estimated_events_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_estimated_events_' + evType],
			'type': lifecycleEventTypeLabels[evType],
			'data_variable': 'estimated_events_' + evType,
			'primary': true,
			'group': groupName,
			'rowspan': 18,
			'format': 'number',
			'description': 'Estimated ' + lifecycleEventTypeLabels[evType] + ' events',
			'filter': filterName
		}));

		self['lc_total_invites_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_total_invites_' + evType],
			'type': 'Total Invites',
			'data_variable': 'total_invites_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_avg_invites_per_event_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_invites_per_event_' + evType],
			'type': 'Avg Invites/Event',
			'data_variable': 'avg_invites_per_event_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'calc_avg': true,
			'fixed_digits': 1,
			'filter': filterName
		}));

		self['lc_avg_invite_fee_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_invite_fee_' + evType],
			'type': 'Avg Invite Fee',
			'data_variable': 'avg_invite_fee_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_events_with_approval_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_with_approval_' + evType],
			'type': 'Events w/ Approval',
			'data_variable': 'events_with_approval_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_approval_rate_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_approval_rate_' + evType],
			'type': 'Approval Rate %',
			'data_variable': 'approval_rate_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_events_no_approval_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_no_approval_' + evType],
			'type': 'Events No Approval',
			'data_variable': 'events_no_approval_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_events_confirmed_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_confirmed_' + evType],
			'type': 'Events Confirmed',
			'data_variable': 'events_confirmed_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_confirm_rate_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_confirm_rate_' + evType],
			'type': 'Confirm Rate %',
			'data_variable': 'confirm_rate_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_confirm_from_approval_rate_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_confirm_from_approval_rate_' + evType],
			'type': 'Confirm/Approval %',
			'data_variable': 'confirm_from_approval_rate_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_no_approval_rate_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_no_approval_rate_' + evType],
			'type': 'No Approval Rate %',
			'data_variable': 'no_approval_rate_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_events_cancelled_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_cancelled_' + evType],
			'type': 'Events Cancelled',
			'data_variable': 'events_cancelled_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_avg_approval_fee_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_approval_fee_' + evType],
			'type': 'Avg Approval Fee',
			'data_variable': 'avg_approval_fee_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_avg_confirm_fee_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_confirm_fee_' + evType],
			'type': 'Avg Confirm Fee',
			'data_variable': 'avg_confirm_fee_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_fee_diff_invite_to_approval_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_fee_diff_invite_to_approval_' + evType],
			'type': 'Fee Diff Invite→Approval',
			'data_variable': 'fee_diff_invite_to_approval_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_fee_diff_invite_to_confirm_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_fee_diff_invite_to_confirm_' + evType],
			'type': 'Fee Diff Invite→Confirm',
			'data_variable': 'fee_diff_invite_to_confirm_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_avg_days_to_approval_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_days_to_approval_' + evType],
			'type': 'Avg Days to Approval',
			'data_variable': 'avg_days_to_approval_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'calc_avg': true,
			'fixed_digits': 1,
			'filter': filterName
		}));

		self['lc_avg_days_to_confirm_' + evType] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_days_to_confirm_' + evType],
			'type': 'Avg Days to Confirm',
			'data_variable': 'avg_days_to_confirm_' + evType,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'calc_avg': true,
			'fixed_digits': 1,
			'filter': filterName
		}));
	});

	// --- USER TYPE BREAKDOWN (NEW VS PAST) ---
	const userTypes = ['new', 'past'];
	const userTypeLabels = {
		'new': 'New Users',
		'past': 'Returning Users'
	};

	userTypes.forEach(function(ut) {
		const groupName = 'lc_ut_' + ut;
		const filterName = 'lc-user-' + ut;

		self['lc_estimated_events_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_estimated_events_' + ut],
			'type': userTypeLabels[ut],
			'data_variable': 'estimated_events_' + ut,
			'primary': true,
			'group': groupName,
			'rowspan': 18,
			'format': 'number',
			'description': 'Estimated events from ' + userTypeLabels[ut].toLowerCase(),
			'filter': filterName
		}));

		self['lc_total_invites_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_total_invites_' + ut],
			'type': 'Total Invites',
			'data_variable': 'total_invites_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_avg_invites_per_event_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_invites_per_event_' + ut],
			'type': 'Avg Invites/Event',
			'data_variable': 'avg_invites_per_event_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'calc_avg': true,
			'fixed_digits': 1,
			'filter': filterName
		}));

		self['lc_avg_invite_fee_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_invite_fee_' + ut],
			'type': 'Avg Invite Fee',
			'data_variable': 'avg_invite_fee_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_events_with_approval_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_with_approval_' + ut],
			'type': 'Events w/ Approval',
			'data_variable': 'events_with_approval_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_approval_rate_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_approval_rate_' + ut],
			'type': 'Approval Rate %',
			'data_variable': 'approval_rate_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_events_no_approval_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_no_approval_' + ut],
			'type': 'Events No Approval',
			'data_variable': 'events_no_approval_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_events_confirmed_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_confirmed_' + ut],
			'type': 'Events Confirmed',
			'data_variable': 'events_confirmed_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_confirm_rate_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_confirm_rate_' + ut],
			'type': 'Confirm Rate %',
			'data_variable': 'confirm_rate_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_confirm_from_approval_rate_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_confirm_from_approval_rate_' + ut],
			'type': 'Confirm/Approval %',
			'data_variable': 'confirm_from_approval_rate_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_no_approval_rate_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_no_approval_rate_' + ut],
			'type': 'No Approval Rate %',
			'data_variable': 'no_approval_rate_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'percent',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_events_cancelled_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_events_cancelled_' + ut],
			'type': 'Events Cancelled',
			'data_variable': 'events_cancelled_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'filter': filterName
		}));

		self['lc_avg_approval_fee_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_approval_fee_' + ut],
			'type': 'Avg Approval Fee',
			'data_variable': 'avg_approval_fee_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_avg_confirm_fee_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_confirm_fee_' + ut],
			'type': 'Avg Confirm Fee',
			'data_variable': 'avg_confirm_fee_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_fee_diff_invite_to_approval_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_fee_diff_invite_to_approval_' + ut],
			'type': 'Fee Diff Invite→Approval',
			'data_variable': 'fee_diff_invite_to_approval_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_fee_diff_invite_to_confirm_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_fee_diff_invite_to_confirm_' + ut],
			'type': 'Fee Diff Invite→Confirm',
			'data_variable': 'fee_diff_invite_to_confirm_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'euro',
			'calc_avg': true,
			'filter': filterName
		}));

		self['lc_avg_days_to_approval_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_days_to_approval_' + ut],
			'type': 'Avg Days to Approval',
			'data_variable': 'avg_days_to_approval_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'calc_avg': true,
			'fixed_digits': 1,
			'filter': filterName
		}));

		self['lc_avg_days_to_confirm_' + ut] = ko.observableArray([]);
		self.lifecycle_variables.push(new KPICountVariable({
			'count_variable': self['lc_avg_days_to_confirm_' + ut],
			'type': 'Avg Days to Confirm',
			'data_variable': 'avg_days_to_confirm_' + ut,
			'group': groupName,
			'subrow': true,
			'format': 'number',
			'calc_avg': true,
			'fixed_digits': 1,
			'filter': filterName
		}));
	});
	//#endregion lifecycle

	// kpis/community-activity EVENT ACTIONS TAB
	/*
	self.event_actions = ko.observableArray([]);


  self.invites = ko.observable([]);

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.invites,
		'type':'Invites',
	    'description': '1 count for every 1 invitation sent from a person or host to an artist',
	    'data_variable':'invites'}));
	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.requests,
		'type':'Requests',
		'description': '1 count for every request sent from an artist to a host',
	    'data_variable':'requests'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.confirms,
		'type':'Total Confirmed',
		'primary': true,
		'description': 'Counted if an event has entered the confirmed state',
	    'data_variable':'confirms'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.confirms_from_invites,
		'type':'Confirms from Invites',
		'description': 'Counted if an event began as a host invite and is now confirmed',
	    'data_variable':'confirms_from_invites'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.confirms_from_requests,
		'type':'Confirms from Requests',
		'description': 'Counted if an event began as an artist request and is now confirmed',
	    'data_variable':'confirms_from_requests'}));




	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.unique_new_user_confirms,
		'type':'New user confirms',
		'description': 'This counts the number of confirms for which this was the first confirm ever for the user.',
	    'data_variable':'unique_new_user_confirms'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.existing_user_confirms,
		'type':'Confirms from Existing Users',
		'description': 'Adds one to the count for every individual confirm that came from a user who has confirmed a concert previous to this month. For example, if 10 concerts are confirmed, and 5 of them are confirmed by booking@sofaconcerts.org (an existing user), this column will show 5. One edge case -- if I am a new user and I confirm two concerts in one month, we will still add 1 to the existing user confirms for the second concert.',
	    'data_variable':'existing_user_confirms'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.existing_user_confirm_rate,
		'type':'Past user confirm %',
		'description': 'The rate of confirms from past user to new users (confirmed by a past user / total confirms )',
	    'data_variable':'existing_user_confirm_rate'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.unique_user_confirms,
		'type':'Confirms from Unique Users',
		'description': 'Counts how many individual users confirmed an event this month. If we have 10 confirms and 9 of them were from booking@sofaconcerts.org and one was from levis@sofaconcerts.org, then we will see a count of 2 here (2 unique users)',
	    'data_variable':'unique_user_confirms'}));


	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.new_user_share,
		'type':'Rate of New users to total users',
		'description': 'Of our unique users confirming a concert, what percentage of them are new users. ( Unique new users / total unique users )',
	    'data_variable':'new_user_share'}));


	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.cancels,
		'type':'Cancelled concerts',
	    'data_variable':'cancels'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.distinct_people,
		'primary': true,
		'description': 'Number of members (incl Artist and Host) that have taken some event action',
		'type':'People Actions',
	    'data_variable':'distinct_people'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.distinct_hosts,
		'type':'Host Actions',
		'description': 'Number of unique hosts that have taken some event action',
	    'data_variable':'distinct_hosts'}));

	self.event_actions.push(new KPICountVariable(
		{'count_variable':self.distinct_artists,
		'type':'Artist Actions',
		'description': 'Number of unique artists that have taken some event action',
		'data_variable':'distinct_artists'}));
	*/

	// kpis/conversion-funnel
	// Overall Conversion (TODO)
	self.overall_conversion = ko.observableArray([]);

	// raw invites
	self.google_traffic = ko.observableArray([]);
  self.signups = ko.observableArray([]);
  self.signups_newsletter = ko.observableArray([]);
  self.signups_no_artists = ko.observableArray([]);

  self.all_nos = ko.observableArray([]);
  self.all_nos_perc = ko.observableArray([]);

  //matchmaking
  self.matchmaking_users = ko.observableArray([]);
  self.matchmaking_users_with_approval = ko.observableArray([]);
  self.matchmaking_users_no_answer_in_48 = ko.observableArray([]);
  self.matchmaking_users_confirm = ko.observableArray([]);


  // estimated events
	self.est_ev_total= ko.observableArray([]);
	self.est_ev_total_fee_avg= ko.observableArray([]);
	self.est_ev_total_fee_total= ko.observableArray([]);
	self.est_ev_total_no_sc= ko.observableArray([]);
	self.est_ev_total_fee_avg_no_sc= ko.observableArray([]);
	self.est_ev_total_fee_total_no_sc= ko.observableArray([]);
	self.est_ev_birthday= ko.observableArray([]);
	self.est_ev_birthday_fee_avg= ko.observableArray([]);
	self.est_ev_birthday_fee_total= ko.observableArray([]);
	self.est_ev_birthday_no_sc= ko.observableArray([]);
	self.est_ev_birthday_fee_avg_no_sc= ko.observableArray([]);
	self.est_ev_birthday_fee_total_no_sc= ko.observableArray([]);
	self.est_ev_corporate_event= ko.observableArray([]);
	self.est_ev_corporate_event_fee_avg= ko.observableArray([]);
	self.est_ev_corporate_event_fee_total= ko.observableArray([]);
	self.est_ev_corporate_event_no_sc= ko.observableArray([]);
	self.est_ev_corporate_event_fee_avg_no_sc= ko.observableArray([]);
	self.est_ev_corporate_event_fee_total_no_sc= ko.observableArray([]);
	self.est_ev_other= ko.observableArray([]);
	self.est_ev_other_fee_avg= ko.observableArray([]);
	self.est_ev_other_fee_total= ko.observableArray([]);
	self.est_ev_other_no_sc= ko.observableArray([]);
	self.est_ev_other_fee_avg_no_sc= ko.observableArray([]);
	self.est_ev_other_fee_total_no_sc= ko.observableArray([]);
	self.est_ev_livestream= ko.observableArray([]);
	self.est_ev_livestream_fee_avg= ko.observableArray([]);
	self.est_ev_livestream_fee_total= ko.observableArray([]);
	self.est_ev_livestream_no_sc= ko.observableArray([]);
	self.est_ev_livestream_fee_avg_no_sc= ko.observableArray([]);
	self.est_ev_livestream_fee_total_no_sc= ko.observableArray([]);

	self.est_ev_sofaconcert= ko.observableArray([]);
	self.est_ev_sofaconcert_fee_avg= ko.observableArray([]);
	self.est_ev_sofaconcert_fee_total= ko.observableArray([]);
	self.est_ev_sofaconcert_no_sc= ko.observableArray([]);
	self.est_ev_sofaconcert_fee_avg_no_sc= ko.observableArray([]);
	self.est_ev_sofaconcert_fee_total_no_sc= ko.observableArray([]);
	self.est_ev_wedding= ko.observableArray([]);
	self.est_ev_wedding_fee_avg= ko.observableArray([]);
	self.est_ev_wedding_fee_total= ko.observableArray([]);
	self.est_ev_wedding_no_sc= ko.observableArray([]);
	self.est_ev_wedding_fee_avg_no_sc= ko.observableArray([]);
	self.est_ev_wedding_fee_total_no_sc= ko.observableArray([]);

	self.conf_ev_total= ko.observableArray([]);
	self.conf_ev_total_fee_avg= ko.observableArray([]);
	self.conf_ev_total_fee_total= ko.observableArray([]);
	self.conf_ev_total_no_sc= ko.observableArray([]);
	self.conf_ev_total_fee_avg_no_sc= ko.observableArray([]);
	self.conf_ev_total_fee_total_no_sc= ko.observableArray([]);
	self.conf_ev_birthday= ko.observableArray([]);
	self.conf_ev_birthday_fee_avg= ko.observableArray([]);
	self.conf_ev_birthday_fee_total= ko.observableArray([]);
	self.conf_ev_birthday_no_sc= ko.observableArray([]);
	self.conf_ev_birthday_fee_avg_no_sc= ko.observableArray([]);
	self.conf_ev_birthday_fee_total_no_sc= ko.observableArray([]);
	self.conf_ev_corporate_event= ko.observableArray([]);
	self.conf_ev_corporate_event_fee_avg= ko.observableArray([]);
	self.conf_ev_corporate_event_fee_total= ko.observableArray([]);
	self.conf_ev_corporate_event_no_sc= ko.observableArray([]);
	self.conf_ev_corporate_event_fee_avg_no_sc= ko.observableArray([]);
	self.conf_ev_corporate_event_fee_total_no_sc= ko.observableArray([]);
	self.conf_ev_other= ko.observableArray([]);
	self.conf_ev_other_fee_avg= ko.observableArray([]);
	self.conf_ev_other_fee_total= ko.observableArray([]);
	self.conf_ev_other_no_sc= ko.observableArray([]);
	self.conf_ev_other_fee_avg_no_sc= ko.observableArray([]);
	self.conf_ev_other_fee_total_no_sc= ko.observableArray([]);
	self.conf_ev_livestream= ko.observableArray([]);
	self.conf_ev_livestream_fee_avg= ko.observableArray([]);
	self.conf_ev_livestream_fee_total= ko.observableArray([]);
	self.conf_ev_livestream_no_sc= ko.observableArray([]);
	self.conf_ev_livestream_fee_avg_no_sc= ko.observableArray([]);
	self.conf_ev_livestream_fee_total_no_sc= ko.observableArray([]);

	self.conf_ev_sofaconcert= ko.observableArray([]);
	self.conf_ev_sofaconcert_fee_avg= ko.observableArray([]);
	self.conf_ev_sofaconcert_fee_total= ko.observableArray([]);
	self.conf_ev_sofaconcert_no_sc= ko.observableArray([]);
	self.conf_ev_sofaconcert_fee_avg_no_sc= ko.observableArray([]);
	self.conf_ev_sofaconcert_fee_total_no_sc= ko.observableArray([]);
	self.conf_ev_wedding= ko.observableArray([]);
	self.conf_ev_wedding_fee_avg= ko.observableArray([]);
	self.conf_ev_wedding_fee_total= ko.observableArray([]);
	self.conf_ev_wedding_no_sc= ko.observableArray([]);
	self.conf_ev_wedding_fee_avg_no_sc= ko.observableArray([]);
	self.conf_ev_wedding_fee_total_no_sc= ko.observableArray([]);

  self.conv_conf_per_est_events_total= ko.observableArray([]);
  self.conv_conf_per_est_events_total_no_sc= ko.observableArray([]);
  self.conv_conf_per_est_events_birthday= ko.observableArray([]);
  self.conv_conf_per_est_events_birthday_no_sc= ko.observableArray([]);
  self.conv_conf_per_est_events_corporate_event= ko.observableArray([]);
  self.conv_conf_per_est_events_corporate_event_no_sc= ko.observableArray([]);
  self.conv_conf_per_est_events_other= ko.observableArray([]);
  self.conv_conf_per_est_events_other_no_sc= ko.observableArray([]);
  self.conv_conf_per_est_events_livestream= ko.observableArray([]);
  self.conv_conf_per_est_events_livestream_no_sc= ko.observableArray([]);
  self.conv_conf_per_est_events_sofaconcert= ko.observableArray([]);
  self.conv_conf_per_est_events_sofaconcert_no_sc= ko.observableArray([]);
  self.conv_conf_per_est_events_wedding= ko.observableArray([]);
  self.conv_conf_per_est_events_wedding_no_sc= ko.observableArray([]);

	/*self.overall_conversion.push(new KPICountVariable(
		{'count_variable':self.google_traffic,
		'type':'Google new users',
		'description': 'Number of new users this month according to google (Eingabe durch maske unten auf der Seite)',
		'format':'number',
		'data_variable':'google_traffic_count'
	}));*/
	self.overall_conversion.push(new KPICountVariable({
		'type':'Signups (w/o artists)',
		'description': 'Neue Anmeldungen (alle abzgl. Künstleranmeldungen)',
		'format':'number',
		'data_variable':'signups',
		'count_variable':self.signups,
		'opt_count_variable':self.signups_no_artists,
		'opt_data_variable':'signups_no_artists'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'Newsletter',
		'description': 'Neue Anmeldungen mit Newsletter',
		'format':'number',
		'data_variable':'signups_newsletter',
		'count_variable':self.signups_newsletter,
	}));

	// est events total
	self.overall_conversion.push(new KPICountVariable({
		'type':'Est. invites (w/o sofa)',
		'description': 'Anzahl der Events mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'primary':true,
		'group':'estimated',
		'rowspan':3,
		'filter':'est-total',
      	'count_variable':self.est_ev_total,
		'data_variable':'est_ev_total',
		'opt_count_variable':self.est_ev_total_no_sc,
    'opt_data_variable':'est_ev_total_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'primary':true,
		'group':'estimated',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
		'filter':'est-total',
  	'count_variable':self.est_ev_total_fee_avg,
		'data_variable':'est_ev_total_fee_avg',
  	'opt_count_variable':self.est_ev_total_fee_avg_no_sc,
		'opt_data_variable':'est_ev_total_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'primary':true,
		'group':'estimated',
		'subrow':true,
		'format':'euro-cut',
		'filter':'est-total',
  	'count_variable':self.est_ev_total_fee_total,
		'data_variable':'est_ev_total_fee_total',
  	'opt_count_variable':self.est_ev_total_fee_total_no_sc,
		'opt_data_variable':'est_ev_total_fee_total_no_sc'
	}));
	// est events sofaconcert
	self.overall_conversion.push(new KPICountVariable({
		'type':'Sofaconcert',
		'description': 'Anzahl der Events der Kategorie "Sofaconert" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'group':'estimated',
		'addpadding':true,
		'rowspan':3,
		'filter':'est-sc',
  	'count_variable':self.est_ev_sofaconcert,
		'data_variable':'est_ev_sofaconcert',
		'opt_count_variable':self.est_ev_sofaconcert_no_sc,
		'opt_data_variable':'est_ev_sofaconcert_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'group':'estimated',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
		'filter':'est-sc',
  	'count_variable':self.est_ev_sofaconcert_fee_avg,
		'data_variable':'est_ev_sofaconcert_fee_avg',
  	'opt_count_variable':self.est_ev_sofaconcert_fee_avg_no_sc,
		'opt_data_variable':'est_ev_sofaconcert_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'group':'estimated',
		'subrow':true,
		'format':'euro-cut',
		'filter':'est-sc',
  	'count_variable':self.est_ev_sofaconcert_fee_total,
		'data_variable':'est_ev_sofaconcert_fee_total',
  	'opt_count_variable':self.est_ev_sofaconcert_fee_total_no_sc,
		'opt_data_variable':'est_ev_sofaconcert_fee_total_no_sc'
	}));
	// est events birthday
	self.overall_conversion.push(new KPICountVariable({
		'type':'Birthday',
		'description': 'Anzahl der Events der Kategorie "Geburstag" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'group':'estimated',
		'addpadding':true,
		'rowspan':3,
		'filter':'est-bday',
  	'count_variable':self.est_ev_birthday,
		'data_variable':'est_ev_birthday',
		'opt_count_variable':self.est_ev_birthday_no_sc,
		'opt_data_variable':'est_ev_birthday_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'group':'estimated',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
		'filter':'est-bday',
  	'count_variable':self.est_ev_birthday_fee_avg,
		'data_variable':'est_ev_birthday_fee_avg',
  	'opt_count_variable':self.est_ev_birthday_fee_avg_no_sc,
		'opt_data_variable':'est_ev_birthday_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'group':'estimated', 'subrow':true,
		'format':'euro-cut',
		'filter':'est-bday',
  	'count_variable':self.est_ev_birthday_fee_total,
		'data_variable':'est_ev_birthday_fee_total',
  	'opt_count_variable':self.est_ev_birthday_fee_total_no_sc,
		'opt_data_variable':'est_ev_birthday_fee_total_no_sc'
	}));
	// est events wedding
	self.overall_conversion.push(new KPICountVariable({
		'type':'Wedding',
		'description': 'Anzahl der Events der Kategorie "Hochzeit" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'group':'estimated',
		'addpadding':true,
		'rowspan':3,
		'filter':'est-wed',
  	'count_variable':self.est_ev_wedding,
		'data_variable':'est_ev_wedding',
		'opt_count_variable':self.est_ev_wedding_no_sc,
		'opt_data_variable':'est_ev_wedding_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'group':'estimated',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
		'filter':'est-wed',
  	'count_variable':self.est_ev_wedding_fee_avg,
		'data_variable':'est_ev_wedding_fee_avg',
  	'opt_count_variable':self.est_ev_wedding_fee_avg_no_sc,
		'opt_data_variable':'est_ev_wedding_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'group':'estimated',
		'subrow':true,
		'format':'euro-cut',
		'filter':'est-wed',
  	'count_variable':self.est_ev_wedding_fee_total,
		'data_variable':'est_ev_wedding_fee_total',
  	'opt_count_variable':self.est_ev_wedding_fee_total_no_sc,
		'opt_data_variable':'est_ev_wedding_fee_total_no_sc'
	}));
	// est events corporate event
	self.overall_conversion.push(new KPICountVariable({
		'type':'Corporate',
		'description': 'Anzahl der Events der Kategorie "corporate event" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'group':'estimated',
		'addpadding':true,
		'rowspan':3,
		'filter':'est-cp',
  	'count_variable':self.est_ev_corporate_event,
		'data_variable':'est_ev_corporate_event',
		'opt_count_variable':self.est_ev_corporate_event_no_sc,
		'opt_data_variable':'est_ev_corporate_event_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'group':'estimated',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
		'filter':'est-cp',
  	'count_variable':self.est_ev_corporate_event_fee_avg,
		'data_variable':'est_ev_corporate_event_fee_avg',
  	'opt_count_variable':self.est_ev_corporate_event_fee_avg_no_sc,
		'opt_data_variable':'est_ev_corporate_event_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'group':'estimated',
		'subrow':true,
		'format':'euro-cut',
		'filter':'est-cp',
  	'count_variable':self.est_ev_corporate_event_fee_total,
		'data_variable':'est_ev_corporate_event_fee_total',
  	'opt_count_variable':self.est_ev_corporate_event_fee_total_no_sc,
		'opt_data_variable':'est_ev_corporate_event_fee_total_no_sc'
	}));
	// est events other
	self.overall_conversion.push(new KPICountVariable({
		'type':'Other',
		'description': 'Anzahl der Events der Kategorie "Other" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'group':'estimated',
		'addpadding':true,
		'rowspan':3,
		'filter':'est-oth',
  	'count_variable':self.est_ev_other,
		'data_variable':'est_ev_other',
		'opt_count_variable':self.est_ev_other_no_sc,
		'opt_data_variable':'est_ev_other_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'group':'estimated',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
		'filter':'est-oth',
  	'count_variable':self.est_ev_other_fee_avg,
		'data_variable':'est_ev_other_fee_avg',
  	'opt_count_variable':self.est_ev_other_fee_avg_no_sc,
		'opt_data_variable':'est_ev_other_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'group':'estimated',
		'subrow':true,
		'format':'euro-cut',
		'filter':'est-oth',
  	'count_variable':self.est_ev_other_fee_total,
		'data_variable':'est_ev_other_fee_total',
  	'opt_count_variable':self.est_ev_other_fee_total_no_sc,
		'opt_data_variable':'est_ev_other_fee_total_no_sc'
	}));
	// est events livestream
	self.overall_conversion.push(new KPICountVariable({
		'type':'Livestream',
		'description': 'Anzahl der Events der Kategorie "livestream" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'group':'estimated',
		'addpadding':true,
		'rowspan':3,
		'filter':'est-liv',
  	'count_variable':self.est_ev_livestream,
		'data_variable':'est_ev_livestream',
		'opt_count_variable':self.est_ev_livestream_no_sc,
		'opt_data_variable':'est_ev_livestream_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'group':'estimated',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
		'filter':'est-liv',
  	'count_variable':self.est_ev_livestream_fee_avg,
		'data_variable':'est_ev_livestream_fee_avg',
  	'opt_count_variable':self.est_ev_livestream_fee_avg_no_sc,
		'opt_data_variable':'est_ev_livestream_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'group':'estimated',
		'subrow':true,
		'format':'euro-cut',
		'filter':'est-liv',
  	'count_variable':self.est_ev_livestream_fee_total,
		'data_variable':'est_ev_livestream_fee_total',
  	'opt_count_variable':self.est_ev_livestream_fee_total_no_sc,
		'opt_data_variable':'est_ev_livestream_fee_total_no_sc'
	}));


	// confirmed events total
	self.overall_conversion.push(new KPICountVariable({
		'type':'Confirms (w/o sofa)',
		'description':'Anzahl der Events mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'primary':true,
		'addpadding':true,
		'rowspan':3,
  	'group':'confirmed',
		'filter':'con-total',
  	'count_variable':self.conf_ev_total,
		'data_variable':'conf_ev_total',
		'opt_count_variable':self.conf_ev_total_no_sc,
    'opt_data_variable':'conf_ev_total_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'primary':true,
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
  	'group':'confirmed',
		'filter':'con-total',
  	'count_variable':self.conf_ev_total_fee_avg,
		'data_variable':'conf_ev_total_fee_avg',
  	'opt_count_variable':self.conf_ev_total_fee_avg_no_sc,
		'opt_data_variable':'conf_ev_total_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'primary':true,
		'subrow':true,
		'format':'euro-cut',
  	'group':'confirmed',
		'filter':'con-total',
  	'count_variable':self.conf_ev_total_fee_total,
		'data_variable':'conf_ev_total_fee_total',
  	'opt_count_variable':self.conf_ev_total_fee_total_no_sc,
		'opt_data_variable':'conf_ev_total_fee_total_no_sc'
	}));
	// conf events sofaconcert
	self.overall_conversion.push(new KPICountVariable({
		'type':'Sofaconcert',
		'description': 'Anzahl der Events der Kategorie "Sofaconert" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'addpadding':true,
		'rowspan':3,
  	'group':'confirmed',
		'filter':'con-sc',
  	'count_variable':self.conf_ev_sofaconcert,
		'data_variable':'conf_ev_sofaconcert',
		'opt_count_variable':self.conf_ev_sofaconcert_no_sc,
		'opt_data_variable':'conf_ev_sofaconcert_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
  	'group':'confirmed',
		'filter':'con-sc',
  	'count_variable':self.conf_ev_sofaconcert_fee_avg,
		'data_variable':'conf_ev_sofaconcert_fee_avg',
  	'opt_count_variable':self.conf_ev_sofaconcert_fee_avg_no_sc,
		'opt_data_variable':'conf_ev_sofaconcert_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'subrow':true,
		'format':'euro-cut',
  	'group':'confirmed',
		'filter':'con-sc',
  	'count_variable':self.conf_ev_sofaconcert_fee_total,
		'data_variable':'conf_ev_sofaconcert_fee_total',
  	'opt_count_variable':self.conf_ev_sofaconcert_fee_total_no_sc,
		'opt_data_variable':'conf_ev_sofaconcert_fee_total_no_sc'
	}));
	// conf events birthday
	self.overall_conversion.push(new KPICountVariable({
		'type':'Birthday',
		'description': 'Anzahl der Events der Kategorie "Geburstag" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'addpadding':true,
		'rowspan':3,
  	'group':'confirmed',
		'filter':'con-bday',
  	'count_variable':self.conf_ev_birthday,
		'data_variable':'conf_ev_birthday',
		'opt_count_variable':self.conf_ev_birthday_no_sc,
		'opt_data_variable':'conf_ev_birthday_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
  	'group':'confirmed',
		'filter':'con-bday',
  	'count_variable':self.conf_ev_birthday_fee_avg,
		'data_variable':'conf_ev_birthday_fee_avg',
  	'opt_count_variable':self.conf_ev_birthday_fee_avg_no_sc,
		'opt_data_variable':'conf_ev_birthday_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'subrow':true,
		'format':'euro-cut',
  	'group':'confirmed',
		'filter':'con-bday',
  	'count_variable':self.conf_ev_birthday_fee_total,
		'data_variable':'conf_ev_birthday_fee_total',
  	'opt_count_variable':self.conf_ev_birthday_fee_total_no_sc,
		'opt_data_variable':'conf_ev_birthday_fee_total_no_sc'
	}));
	// conf events wedding
	self.overall_conversion.push(new KPICountVariable({
		'type':'Wedding',
		'description': 'Anzahl der Events der Kategorie "Hochzeit" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'addpadding':true,
		'rowspan':3,
  	'group':'confirmed',
		'filter':'con-wed',
  	'count_variable':self.conf_ev_wedding,
		'data_variable':'conf_ev_wedding',
		'opt_count_variable':self.conf_ev_wedding_no_sc,
		'opt_data_variable':'conf_ev_wedding_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
  	'group':'confirmed',
		'filter':'con-wed',
  	'count_variable':self.conf_ev_wedding_fee_avg,
		'data_variable':'conf_ev_wedding_fee_avg',
  	'opt_count_variable':self.conf_ev_wedding_fee_avg_no_sc,
		'opt_data_variable':'conf_ev_wedding_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'subrow':true,
		'format':'euro-cut',
  	'group':'confirmed',
		'filter':'con-wed',
  	'count_variable':self.conf_ev_wedding_fee_total,
		'data_variable':'conf_ev_wedding_fee_total',
  	'opt_count_variable':self.conf_ev_wedding_fee_total_no_sc,
		'opt_data_variable':'conf_ev_wedding_fee_total_no_sc'
	}));
	// conf events corporate event
	self.overall_conversion.push(new KPICountVariable({
		'type':'Corporate',
		'description': 'Anzahl der Events der Kategorie "corporate event" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'addpadding':true,
		'rowspan':3,
  	'group':'confirmed',
		'filter':'con-cp',
  	'count_variable':self.conf_ev_corporate_event,
		'data_variable':'conf_ev_corporate_event',
		'opt_count_variable':self.conf_ev_corporate_event_no_sc,
		'opt_data_variable':'conf_ev_corporate_event_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
  	'group':'confirmed',
  	'count_variable':self.conf_ev_corporate_event_fee_avg,
		'filter':'con-cp',
		'data_variable':'conf_ev_corporate_event_fee_avg',
  	'opt_count_variable':self.conf_ev_corporate_event_fee_avg_no_sc,
		'opt_data_variable':'conf_ev_corporate_event_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'subrow':true,
		'format':'euro-cut',
  	'group':'confirmed',
		'filter':'con-cp',
  	'count_variable':self.conf_ev_corporate_event_fee_total,
		'data_variable':'conf_ev_corporate_event_fee_total',
  	'opt_count_variable':self.conf_ev_corporate_event_fee_total_no_sc,
		'opt_data_variable':'conf_ev_corporate_event_fee_total_no_sc'
	}));
	// conf events other
	self.overall_conversion.push(new KPICountVariable({
		'type':'Other',
		'description': 'Anzahl der Events der Kategorie "Other" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'addpadding':true,
		'rowspan':3,
  	'group':'confirmed',
		'filter':'con-oth',
  	'count_variable':self.conf_ev_other,
		'data_variable':'conf_ev_other',
		'opt_count_variable':self.conf_ev_other_no_sc,
		'opt_data_variable':'conf_ev_other_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
  	'group':'confirmed',
		'filter':'con-oth',
  	'count_variable':self.conf_ev_other_fee_avg,
		'data_variable':'conf_ev_other_fee_avg',
  	'opt_count_variable':self.conf_ev_other_fee_avg_no_sc,
		'opt_data_variable':'conf_ev_other_fee_avg_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'subrow':true,
		'format':'euro-cut',
  	'group':'confirmed',
		'filter':'con-oth',
  	'count_variable':self.conf_ev_other_fee_total,
		'data_variable':'conf_ev_other_fee_total',
  	'opt_count_variable':self.conf_ev_other_fee_total_no_sc,
		'opt_data_variable':'conf_ev_other_fee_total_no_sc'
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Livestream',
		'description': 'Anzahl der Events der Kategorie "Livestream" mit Einladung (ohne Events vom SC Booking Account)',
		'format':'number',
		'addpadding':true,
		'rowspan':3,
  	'group':'confirmed',
		'filter':'con-liv',
  	'count_variable':self.conf_ev_livestream,
		'data_variable':'conf_ev_livestream',
		'opt_count_variable':self.conf_ev_livestream_no_sc,
		'opt_data_variable':'conf_ev_livestream_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'ø fee €',
		'subrow':true,
		'format':'eur',
		'calc_avg':true,
  	'group':'confirmed',
		'filter':'con-liv',
  	'count_variable':self.conf_ev_livestream_fee_avg,
		'data_variable':'conf_ev_livestream_fee_avg',
  	'opt_count_variable':self.conf_ev_livestream_fee_avg_no_sc,
		'opt_data_variable':'conf_ev_livestream_fee_avg_no_sc'
	}));


	self.overall_conversion.push(new KPICountVariable({
		'type':'total fee k€',
		'subrow':true,
		'format':'euro-cut',
  	'group':'confirmed',
		'filter':'con-liv',
  	'count_variable':self.conf_ev_livestream_fee_total,
		'data_variable':'conf_ev_livestream_fee_total',
  	'opt_count_variable':self.conf_ev_livestream_fee_total_no_sc,
		'opt_data_variable':'conf_ev_livestream_fee_total_no_sc'
	}));

  // conversion form invites to confirmed
	self.overall_conversion.push(new KPICountVariable({
		'type':'total % confirms to invites',
		'description':'%-Satz Buchungen zu Einladungen (ohne SC Booking Account)',
		'primary':true,
		'format':'percent',
  	'group':'conversion',
  	'count_variable':self.conv_conf_per_est_events_total,
		'data_variable':'conv_conf_per_est_events_total',
  	'opt_count_variable':self.conv_conf_per_est_events_total_no_sc,
		'opt_data_variable':'conv_conf_per_est_events_total_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'Sofaconcert',
		'description':'%-Satz Buchungen zu Einladungen (ohne SC Booking Account)',
		'format':'percent',
  	'group':'conversion',
  	'count_variable':self.conv_conf_per_est_events_sofaconcert,
		'data_variable':'conv_conf_per_est_events_sofaconcert',
  	'opt_count_variable':self.conv_conf_per_est_events_sofaconcert_no_sc,
		'opt_data_variable':'conv_conf_per_est_events_sofaconcert_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'Birthday',
		'description':'%-Satz Buchungen zu Einladungen (ohne SC Booking Account)',
		'format':'percent',
  	'group':'conversion',
  	'count_variable':self.conv_conf_per_est_events_birthday,
		'data_variable':'conv_conf_per_est_events_birthday',
  	'opt_count_variable':self.conv_conf_per_est_events_birthday_no_sc,
		'opt_data_variable':'conv_conf_per_est_events_birthday_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'Wedding',
		'description':'%-Satz Buchungen zu Einladungen (ohne SC Booking Account)',
		'format':'percent',
  	'group':'conversion',
  	'count_variable':self.conv_conf_per_est_events_wedding,
		'data_variable':'conv_conf_per_est_events_wedding',
  	'opt_count_variable':self.conv_conf_per_est_events_wedding_no_sc,
		'opt_data_variable':'conv_conf_per_est_events_wedding_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'Corporate',
		'description':'%-Satz Buchungen zu Einladungen (ohne SC Booking Account)',
		'format':'percent',
  	'group':'conversion',
  	'count_variable':self.conv_conf_per_est_events_corporate_event,
		'data_variable':'conv_conf_per_est_events_corporate_event',
  	'opt_count_variable':self.conv_conf_per_est_events_corporate_event_no_sc,
		'opt_data_variable':'conv_conf_per_est_events_corporate_event_no_sc'
	}));
	self.overall_conversion.push(new KPICountVariable({
		'type':'Other',
		'description':'%-Satz Buchungen zu Einladungen (ohne SC Booking Account)',
		'format':'percent',
  	'group':'conversion',
  	'count_variable':self.conv_conf_per_est_events_other,
		'data_variable':'conv_conf_per_est_events_other',
  	'opt_count_variable':self.conv_conf_per_est_events_other_no_sc,
		'opt_data_variable':'conv_conf_per_est_events_other_no_sc'
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Livestream',
		'description':'%-Satz Buchungen zu Einladungen (ohne SC Booking Account)',
		'format':'percent',
  	'group':'conversion',
  	'count_variable':self.conv_conf_per_est_events_livestream,
		'data_variable':'conv_conf_per_est_events_livestream',
  	'opt_count_variable':self.conv_conf_per_est_events_livestream_no_sc,
		'opt_data_variable':'conv_conf_per_est_events_livestream_no_sc'
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Est Invites that received all nos',
		'description': 'A user that received all nos from artists invites',
		'format':'number',
		'data_variable':'all_nos',
		'count_variable':self.all_nos,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Est Invites that received all nos (percent)',
		'description': 'A user that received all nos from artists invites',
		'format':'percent',
		'data_variable':'all_nos_perc_total',
		'count_variable':self.all_nos_perc,
	}));

    //Receommendation Funnel
    //

    self.recs_inserted = ko.observableArray([]);
	self.avg_match_per_rec = ko.observableArray([]);
	self.avg_approve_per_rec = ko.observableArray([]);
	self.recs_with_return_message_from_host  = ko.observableArray([]);
	self.recs_with_return_message_from_host_perct  = ko.observableArray([]);
	self.rec_approvals = ko.observableArray([]);
	self.rec_approval_perct = ko.observableArray([]);
	self.approvals_under_48 = ko.observableArray([]);
	self.approvals_under_48_perct = ko.observableArray([]);
	self.approvals_under_24 = ko.observableArray([]);
	self.approvals_under_24_perct = ko.observableArray([]);
	self.match_confirms = ko.observableArray([]);
	self.match_confirms_perct = ko.observableArray([]);
	self.match_confirms_approvals_perct = ko.observableArray([]);
	self.rec_total_confirms = ko.observableArray([]);
	self.rec_total_confirms_perct  = ko.observableArray([]);


	self.overall_conversion.push(new KPICountVariable({
		'type':'Recommendations',
		'primary':true,
		'description': 'Users that requested a recommendation',
		'format':'number',
		'data_variable':'recs_inserted',
		'count_variable':self.recs_inserted,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Avg matches sent / rec',
		'description': 'What is the average number of admin match to artists did we send',
		'format':'number',
		'data_variable':'avg_match_per_rec',
		'count_variable':self.avg_match_per_rec,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Avg approves per rec',
		'description': 'How many approvals does each recommendation have',
		'format':'number',
		'data_variable':'avg_approve_per_rec',
		'count_variable':self.avg_approve_per_rec,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Approval',
		'description': 'Recommendations with at least one approval',
		'format':'number',
        'primary': true,
		'data_variable':'rec_approvals',
		'count_variable':self.rec_approvals,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Approval %',
		'description': '% Recommendations with at least one approval',
		'format':'percent',
		'data_variable':'rec_approval_perct',
		'count_variable':self.rec_approval_perct,
	}));


	self.overall_conversion.push(new KPICountVariable({
		'type':'Recommendations with a return msg from host',
		'description': 'How many of our recommendations include messages back from the host',
		'format':'number',
		'data_variable':'recs_with_return_message_from_host',
		'count_variable':self.recs_with_return_message_from_host,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Recommendations with a return msg from host %',
		'description': 'How many of our recommendations include messages back from the host',
		'format':'percent',
		'data_variable':'recs_with_return_message_from_host_perct',
		'count_variable':self.recs_with_return_message_from_host_perct,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Recommendations with an approval under 48 hours',
		'description': 'How many of our recommendations received their first approval within 48 hours',
		'format':'number',
		'data_variable':'approvals_under_48',
		'count_variable':self.approvals_under_48,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Recommendations with an approval under 48 hours %',
		'description': 'How many of our recommendations received their first approval within 48 hours',
		'format':'percent',
		'data_variable':'approvals_under_48_perct',
		'count_variable':self.approvals_under_48_perct,
	}));


	self.overall_conversion.push(new KPICountVariable({
		'type':'Recommendations with an approval under 24 hours',
		'description': 'How many of our recommendations received their first approval within 24 hours',
		'format':'number',
		'data_variable':'approvals_under_24',
		'count_variable':self.approvals_under_24,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Recommendations with an approval under 24 hours %',
		'description': 'How many of our recommendations received their first approval within 24 hours',
		'format':'percent',
		'data_variable':'approvals_under_24_perct',
		'count_variable':self.approvals_under_24_perct,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Confirms from Matchmaking',
		'primary':true,
		'description': 'If a confirm came from one of our gig matching feature, then it is counted here.',
		'format':'number',
		'data_variable':'match_confirms',
		'count_variable':self.match_confirms,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Confirms from Matchmaking %',
		'description': 'If a confirm came from one of our gig matching feature, then it is counted here.',
		'format':'percent',
		'data_variable':'match_confirms_perct',
		'count_variable':self.match_confirms_perct,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Confirms from Approvals %',
		'description': 'Percentage based on total number of approvals (real conversion rate).',
		'format':'percent',
		'data_variable':'match_confirms_approvals_perct',
		'count_variable':self.match_confirms_approvals_perct,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Total Confirms',
		'description': 'If the recommendation has a confirm, count it here',
		'format':'number',
		'data_variable':'rec_total_confirms',
		'count_variable':self.rec_total_confirms,
	}));

	self.overall_conversion.push(new KPICountVariable({
		'type':'Total Confirms %',
		'description': 'If the recommendation has a confirm, count it here',
		'format':'percent',
		'data_variable':'rec_total_confirms_perct',
		'count_variable':self.rec_total_confirms_perct,
	}));





    self.lookup_user_kpi_data = function(){
        return $.ajax({

            url: self.web_host + '/api/kpi/users',
            type: 'GET',
            data:{
            },
            contentType: "application/json; charset=utf-8",

            success: function (data) {
              if(data.success){
                  ko.utils.arrayForEach(self.member_count_variables(), function(item){

                      if(item.data_variable in data){
                              item.count_variable(ko.utils.arrayMap(data[item.data_variable] || [], function(x){
                                  x.rootvm = self.rootvm;
                    x.count_format = item.format;

                                return new KPIVariableCount(x);
                    }));
                    if (item.opt_count_variable) {
                                item.opt_count_variable(ko.utils.arrayMap(data[item.opt_data_variable] || [], function(x){
                                    x.rootvm = self.rootvm;
                      x.count_format = item.format;

                                  return new KPIVariableCount(x);
                      }));
                    }
                      }
                      });
              }
            },

            error: function (data) {
                console.log(data.statusText);
            }
        });
	};

    self.lookup_balance_kpi_data = function(){

        return $.ajax({

            url: self.web_host + '/api/kpi/balance',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                if(data.success){

			        ko.utils.arrayForEach(self.balance_variables(), function(item){

						item.count_variable(ko.utils.arrayMap(data[item.data_variable] || [],
							function(x){
							x.rootvm = self.rootvm;
                            x.count_format = item.format;

							return new KPIVariableCount(x);
	                    }));

                        if (item.opt_count_variable) {
                            item.opt_count_variable(ko.utils.arrayMap(
                                  data[item.opt_data_variable] || [],
                                  function(x){
                                            x.rootvm = self.rootvm;
                                            x.count_format = item.format;

                                          return new KPIVariableCount(x);
                           }));
                        }


					});

                }
            },

            error: function (data) {
                console.log(data.statusText);
            }
        });
    };


    self.lookup_funnel_kpi_data = function(){
        return $.ajax({
            url: self.web_host + '/api/kpi/funnel',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                if(data.success){

			        ko.utils.arrayForEach(self.member_count_variables(), function(item){

                        if(item.data_variable in data){
                            item.count_variable(ko.utils.arrayMap(data[item.data_variable] || [],
                                function(x){
                                x.rootvm = self.rootvm;
                                x.count_format = item.format;
                                return new KPIVariableCount(x);
                            }));

                            if (item.opt_count_variable) {
                                item.opt_count_variable(ko.utils.arrayMap(
                                      data[item.opt_data_variable] || [],
                                      function(x){
                                                x.rootvm = self.rootvm;
                                                x.count_format = item.format;

                                              return new KPIVariableCount(x);
                               }));
                            }
                        }


					});
                }
            },

            error: function (data) {
                console.log(data.statusText);
            }
        });
    };
    self.lookup_cashflow_data = function(){
        return $.ajax({
            url: self.web_host + '/api/kpi/cashflow',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                if(data.success){

			        ko.utils.arrayForEach(self.cashflow_variables(), function(item){

						item.count_variable(ko.utils.arrayMap(data[item.data_variable] || [],
							function(x){
							x.rootvm = self.rootvm;
                            x.count_format = item.format;
							return new KPIVariableCount(x);
	                    }));

                        if (item.opt_count_variable) {
                            item.opt_count_variable(ko.utils.arrayMap(
                                  data[item.opt_data_variable] || [],
                                  function(x){
                                            x.rootvm = self.rootvm;
                                            x.count_format = item.format;

                                          return new KPIVariableCount(x);
                           }));
                        }


					});

                }
            },

            error: function (data) {
                console.log(data.statusText);
            }
        });
    };


  self.lookup_overall_conversion = function(){
    return $.ajax({
      url: self.web_host + '/api/kpi/overall-conversion',
      type: 'GET',
      contentType: "application/json; charset=utf-8",

      success: function (data) {
        if(data.success){
             console.log(data.all_nos);
		     ko.utils.arrayForEach(self.overall_conversion(), function(item){
			      item.count_variable(ko.utils.arrayMap(data[item.data_variable] || [],
				      function(x){
					      x.rootvm = self.rootvm;
                          x.count_format = item.format;

  				      return new KPIVariableCount(x);
	          }));
            if (item.opt_count_variable) {
  		        item.opt_count_variable(ko.utils.arrayMap(data[item.opt_data_variable] || [],
  		          function(x){
					 x.rootvm = self.rootvm;
                     x.count_format = item.format;

  		            return new KPIVariableCount(x);
               }));
            }
			    });
        }
      },
      error: function (data) {
        console.log(data.statusText);
      }
    });
  }

  self.lookup_acquisition_funnel = function(){
    return $.ajax({
      url: self.web_host + '/api/kpi/acquisition-funnel',
      type: 'GET',
      contentType: "application/json; charset=utf-8",

      success: function (data) {
        if(data.success){
          ko.utils.arrayForEach(self.acquisition_variables(), function(item){
            if(item.data_variable in data){
              item.count_variable(ko.utils.arrayMap(data[item.data_variable] || [],
                function(x){
                  x.rootvm = self.rootvm;
                  x.count_format = item.format;
                  return new KPIVariableCount(x);
                }));
            }
          });
        }
      },
      error: function (data) {
        console.log(data.statusText);
      }
    });
  }

  self.lookup_event_lifecycle = function(){
    return $.ajax({
      url: self.web_host + '/api/kpi/event-lifecycle',
      type: 'GET',
      contentType: "application/json; charset=utf-8",

      success: function (data) {
        if(data.success){
          ko.utils.arrayForEach(self.lifecycle_variables(), function(item){
            if(item.data_variable in data){
              item.count_variable(ko.utils.arrayMap(data[item.data_variable] || [],
                function(x){
                  x.rootvm = self.rootvm;
                  x.count_format = item.format;
                  return new KPIVariableCount(x);
                }));
            }
          });
        }
      },
      error: function (data) {
        console.log(data.statusText);
      }
    });
  }


    self.lookup_external_balances = function(){
        return $.ajax({

            url: self.web_host + '/api/admin/external-balances',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                if(data.success){
			        self.external_balances(ko.utils.arrayMap(
                        data.external_balances || [], function(item){
                        return new ExternalBalance(item)
					}));
                }
            },

            error: function (data) {
                console.log(data.statusText);
            }
        });
    };

    self.lookup_google_counts = function(){
        return $.ajax({

            url: self.web_host + '/api/admin/lookup-google-counts',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                if(data.success){
			        self.google_traffic_counts(ko.utils.arrayMap(
                        data.google_traffic_counts || [], function(item){
                        return new GoogleTrafficCount(item)
					}));
                }
            },

            error: function (data) {
                console.log(data.statusText);
            }
        });
    };




    // Add at the bottom the ability to add 'balance' or 'external'
    // receipts
    //
    self.show_external_balance = ko.observable(false);

    self.external_balances = ko.observableArray([]);
    self.is_expense = ko.observable(false);
    self.external_balance_date = ko.observable(new moment());
    self.external_balance_amount = ko.observable();
    self.external_balance_netto = ko.observable();
    self.external_extra_notes = ko.observable();
    self.external_cloud_link = ko.observable();
    self.related_fee = ko.observable();
    self.related_external = ko.observable();
    self.due_date = ko.observable();
    self.cost_center = ko.observable();

    self.external_receiver_name = ko.observable();
    self.external_balance_invoice_number = ko.observable();

    self.disable_add_amount = ko.computed(function(){
        if(self.is_expense()){
            return !(self.external_balance_date() && self.external_balance_amount() &&
                self.external_balance_netto() && self.related_fee() &&
                self.related_external() && self.cost_center()) ;
        }
        else{
            return !(self.external_balance_date() && self.external_balance_amount() && self.external_balance_netto() &&
                self.external_receiver_name() && self.external_balance_invoice_number() &&
                self.cost_center() );

        }
    });

	// Google Traffic Counts
    self.show_google_traffic_count = ko.observable(false);

    self.google_traffic_counts = ko.observableArray([]);
    self.google_traffic_count_date = ko.observable(new moment());
    self.google_traffic_count = ko.observable();
    self.google_traffic_extra_notes = ko.observable();

    self.disable_add_count = ko.computed(function(){
        return !(self.google_traffic_count_date() && self.google_traffic_count());
    });

    self.delete_google_traffic_count = function(google_traffic_count){
        return $.ajax({

            url: self.web_host + '/api/admin/delete-google-count',
            type: 'POST',
            data:ko.toJSON({
                google_traffic_count_uuid: google_traffic_count.google_traffic_count_uuid(),
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   self.google_traffic_counts.remove(google_traffic_count)
                   self.lookup_balance_kpi_data();
                 self.notfy.success("Removed!");
               }
               else{
                 self.notfy.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
              self.notfy.error(response.message);
            },
            complete: function(){
            }
        });
    };


    self.save_google_traffic_count = function(){

        return $.ajax({

            url: self.web_host + '/api/admin/add-google-traffic-count',
            type: 'POST',
            data:ko.toJSON({
                date: self.google_traffic_count_date(),
                count: self.google_traffic_count(),
                extra_notes: self.google_traffic_extra_notes(),
            }),
            processData: false,

            contentType: "application/json; charset=utf-8",

            success: function (data) {

               if (data.success){
                   self.lookup_google_counts();
                   self.google_traffic_counts.push(new GoogleTrafficCount(data.google_traffic_count))
                   self.external_extra_notes(undefined);
                   self.google_traffic_count(undefined);
                 self.notfy.success("Added!");
               }
               else{
                 self.notfy.error(data.message);
               }

            },
            error: function (jqXHR, errorStatus, thrownError) {
                var response = jQuery.parseJSON(jqXHR.responseText);
              self.notfy.error(response.message);
            },
            complete: function(){
            }
        });
	};
};

function ExternalBalance(data){
	var self = this;
	self.type = "ExternalBalance"

    self.external_balance_uuid = ko.observable(data.external_balance_uuid);
    self.external_balance_amount = ko.observable(data.external_balance_amount);
    self.external_balance_netto = ko.observable(data.external_balance_netto);
    self.locale_external_balance = ko.pureComputed(function(){
        if(self.external_balance_amount()){
            return self.external_balance_amount().toLocaleString();
        }
    });
    self.locale_external_balance_netto = ko.pureComputed(function(){
        if(self.external_balance_netto()){
            return self.external_balance_netto().toLocaleString();
        }

    });

    self.external_balance_date = ko.observable(new moment(data.external_balance_date));
    self.cost_center = ko.observable(data.cost_center);
    self.external_cloud_link = ko.observable(data.external_cloud_link);

    self.external_balance_invoice_number = ko.observable(data.external_balance_invoice_number);
    self.payin_date = ko.observable();
    self.is_expense = ko.observable(data.is_expense);

    if(data.payin_date){
        self.payin_date(new moment(data.payin_date).format('DD.MM.YY'));
    }

    self.due_date = ko.observable();
    if(data.due_date){
        self.due_date(new moment(data.due_date));
    }

    self.pretty_due_date = ko.pureComputed(function(){
        if(self.due_date()){
            return self.due_date().format('DD.MM.YY')
        }
    });



    self.receiver_name = ko.observable(data.receiver_name);

    self.extra_notes = ko.observable(data.extra_notes);

    self.mark_as_paid_in = function(){

        var answer = confirm('Confirm external invoice Payin RS-' + self.external_balance_invoice_number());

        if (answer){
            return $.ajax({

                url: '/api/admin/external-balance/pay-in',
                type: 'POST',
                data:ko.toJSON({
                    external_balance_uuid: self.external_balance_uuid(),
                }),
                processData: false,


                contentType: "application/json; charset=utf-8",

                success: function (data) {

                   if (data.success){
                       console.log(data.payin_date);
                       self.payin_date(
                           new moment(data.payin_date).format('DD.MM.YY'));
                     self.notfy.success("Paid!");
                   }
                   else{
                     self.notfy.error(data.message || 'Something did not work right');
                   }

                },
                error: function (data) {
                  self.notfy.error(data);
                },
                complete: function(){
                }
            });
        }
    };

}

function GoogleTrafficCount(data){
	var self = this;
	self.type = "GoogleTrafficCount"

    self.google_traffic_count_uuid = ko.observable(data.google_traffic_count_uuid);
    self.google_traffic_count = ko.observable(data.google_traffic_count);
	self.google_traffic_count_date = ko.observable(data.google_traffic_count_date);
    self.extra_notes = ko.observable(data.extra_notes);
}


